import {
  LanguageLinks,
  ParsedLanguageLinks,
  Language,
  EntityOperation,
  ParsedEntityOperation,
  EntityOperations,
  ParsedEntityOperations,
  IntegerItem,
  FieldItemList,
  UuidItem,
  LanguageItem,
  EntityReferenceNodeTypeItem,
  ParsedEntityReferenceNodeTypeItem,
  TimestampItem,
  EntityReferenceUserItem,
  ParsedEntityReferenceUserItem,
  StringItem,
  BooleanItem,
  MetatagComputedItem,
  ParsedMetatagComputedItem,
  PathItem,
  ListStringItem,
  NodeBase,
  ParsedNodeBase,
  EntityReferenceParagraphsTypeItem,
  ParsedEntityReferenceParagraphsTypeItem,
  ParagraphBase,
  ParsedParagraphBase,
  ProductDbEntityItem,
  ListIntegerItem,
  ParagraphActivityCluster,
  ParsedParagraphActivityCluster,
  Paragraph,
  EntityReferenceMediaTypeItem,
  ParsedEntityReferenceMediaTypeItem,
  FileUriItem,
  FileBase,
  ParsedFileBase,
  Styles,
  ParsedStyles,
  FileImage,
  ParsedFileImage,
  File,
  FileOther,
  ParsedFileOther,
  ParsedFile,
  Entity,
  ImageFileWithTargetItem,
  ParsedImageFileWithTargetItem,
  MediaBase,
  ParsedMediaBase,
  FileFileWithTargetItem,
  ParsedFileFileWithTargetItem,
  MediaDocument,
  ParsedMediaDocument,
  Media,
  MediaImage,
  ParsedMediaImage,
  VideoEmbedFieldItem,
  ParsedVideoEmbedFieldItem,
  MediaVideo,
  ParsedMediaVideo,
  ParsedMedia,
  EntityReferenceMediaWithTargetParagraphBookFieldImageItem,
  LinkItem,
  ParsedLinkItem,
  ParagraphBook,
  ParsedParagraphBook,
  EntityReferenceRevisionsParagraphWithTargetParagraphBooksFieldBooksItem,
  ParagraphBooks,
  ParsedParagraphBooks,
  EntityReferenceRevisionsParagraphWithTargetParagraphCarousselFieldContentGridItemsItem,
  ParsedParagraphContentGridVideo,
  ParsedParagraphContentGridItem,
  ParagraphContentGridVideo,
  ParagraphContentGridItem,
  ParagraphCaroussel,
  ParsedParagraphCaroussel,
  EntityReferenceRevisionsParagraphWithTargetParagraphCollectionFieldCollectionGroupsItem,
  ParsedParagraphCollectionGroup,
  ParagraphCollectionGroup,
  TextItem,
  ParagraphCollection,
  ParsedParagraphCollection,
  EntityReferenceRevisionsParagraphWithTargetParagraphCollectionGroupFieldCollectionItemsItem,
  ParsedParagraphCollectionItem,
  ParagraphCollectionItem,
  ParagraphCollectionSearchBar,
  ParsedParagraphCollectionSearchBar,
  EntityReferenceRevisionsParagraphWithTargetParagraphContentGridFieldContentGridItemsItem,
  ParagraphContentGrid,
  ParsedParagraphContentGrid,
  EntityReferenceMediaWithTargetParagraphContentGridItemFieldImageItem,
  EntityReferenceMediaWithTargetParagraphCoreActivityClusterFieldImageItem,
  ParagraphCoreActivityCluster,
  ParsedParagraphCoreActivityCluster,
  ParagraphCtaBlock,
  ParsedParagraphCtaBlock,
  ParagraphDatetime,
  ParsedParagraphDatetime,
  ParagraphExpanderItem,
  ParsedParagraphExpanderItem,
  EntityReferenceRevisionsParagraphWithTargetParagraphExpandersFieldExpanderItemsItem,
  ParagraphExpanders,
  ParsedParagraphExpanders,
  EntityReferenceNodeWithTargetParagraphFaqCollectionFieldFaqItemItem,
  ParsedNodeFaq,
  NodeFaq,
  ParagraphFaqCollection,
  ParsedParagraphFaqCollection,
  EntityReferenceMediaWithTargetParagraphFeaturedContentFieldImageItem,
  ParagraphFeaturedContent,
  ParsedParagraphFeaturedContent,
  ParagraphFormstackBlock,
  ParsedParagraphFormstackBlock,
  EntityReferenceRevisionsParagraphWithTargetParagraphGridBlockFieldGridItemsItem,
  ParsedParagraphGridItems,
  ParagraphGridItems,
  ParagraphGridBlock,
  ParsedParagraphGridBlock,
  EntityReferenceMediaWithTargetParagraphGridItemsFieldMediaItem,
  ParagraphHighlight,
  ParsedParagraphHighlight,
  ParagraphIframe,
  ParsedParagraphIframe,
  EntityReferenceMediaWithTargetParagraphImagesFieldImagesItem,
  ParagraphImages,
  ParsedParagraphImages,
  EntityReferenceMediaWithTargetParagraphInlineMediaFieldMediaItem,
  ParagraphInlineMedia,
  ParsedParagraphInlineMedia,
  ParagraphKnop,
  ParsedParagraphKnop,
  ParagraphLocation,
  ParsedParagraphLocation,
  EntityReferenceMediaWithTargetParagraphMediaFieldMediaItem,
  ParagraphMedia,
  ParsedParagraphMedia,
  ParagraphNewsletterSignupForm,
  ParsedParagraphNewsletterSignupForm,
  ParagraphOpeningHours,
  ParsedParagraphOpeningHours,
  EntityReferenceNodeItem,
  ParsedEntityReferenceNodeItem,
  ParagraphPageGrid,
  ParsedParagraphPageGrid,
  EntityReferenceMediaWithTargetParagraphPanoramaFieldImageItem,
  ParagraphPanorama,
  ParsedParagraphPanorama,
  ParagraphQuote,
  ParsedParagraphQuote,
  ParagraphRecentNews,
  ParsedParagraphRecentNews,
  EntityReferenceRevisionsParagraphWithTargetParagraphSubmenuFieldItemsItem,
  ParsedParagraphSubmenuItem,
  ParagraphSubmenuItem,
  ParagraphSubmenu,
  ParsedParagraphSubmenu,
  EntityReferenceRevisionsParagraphWithTargetParagraphSubscriptionBlockFieldSubscriptionItemItem,
  ParsedParagraphSubscriptions,
  ParagraphSubscriptions,
  ParagraphSubscriptionBlock,
  ParsedParagraphSubscriptionBlock,
  EntityReferenceRevisionsParagraphWithTargetParagraphTextFieldInlineMediaItem,
  ParagraphText,
  ParsedParagraphText,
  ParagraphThemakiezerEmbed,
  ParsedParagraphThemakiezerEmbed,
  ParagraphTippedActivitiesBlock,
  ParsedParagraphTippedActivitiesBlock,
  EntityReferenceTaxonomyTermItem,
  ParsedEntityReferenceTaxonomyTermItem,
  ParagraphVacancyOverview,
  ParsedParagraphVacancyOverview,
  ParagraphWordcloudBlock,
  ParsedParagraphWordcloudBlock,
  ParsedParagraph,
  EntityReferenceRevisionsParagraphWithTargetNodeActivityClustersFieldCoreActivityClustersItem,
  EntityReferenceMediaWithTargetNodeActivityClustersFieldMediaItem,
  MetatagItem,
  NodeActivityClusters,
  ParsedNodeActivityClusters,
  Node,
  EntityReferenceMediaWithTargetNodeActivityDetailFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeActivityDetailFieldParagraphsItem,
  NodeActivityDetail,
  ParsedNodeActivityDetail,
  EntityReferenceMediaWithTargetNodeBlogOverviewFieldMediaItem,
  NodeBlogOverview,
  ParsedNodeBlogOverview,
  EntityReferenceMediaWithTargetNodeBlogPostFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeBlogPostFieldParagraphsItem,
  NodeBlogPost,
  ParsedNodeBlogPost,
  EntityReferenceMediaWithTargetNodeCollectionOverviewFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeCollectionOverviewFieldParagraphsItem,
  EntityReferenceRevisionsParagraphWithTargetNodeCollectionOverviewFieldParagraphsHeaderItem,
  NodeCollectionOverview,
  ParsedNodeCollectionOverview,
  EntityReferenceMediaWithTargetNodeEventFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeEventFieldParagraphsItem,
  NodeEvent,
  ParsedNodeEvent,
  EntityReferenceMediaWithTargetNodeHomeFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeHomeFieldParagraphsItem,
  EntityReferenceRevisionsParagraphWithTargetNodeHomeFieldUniversalParagraphsItem,
  NodeHome,
  ParsedNodeHome,
  EntityReferenceMediaWithTargetNodeLocationFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeLocationFieldParagraphsItem,
  EntityReferenceRevisionsParagraphWithTargetNodeLocationFieldParagraphsUpperItem,
  NodeLocation,
  ParsedNodeLocation,
  AddressItem,
  ParsedAddressItem,
  EmailItem,
  EntityReferenceRevisionsParagraphWithTargetNodeLocationDetailFieldLocationOpeningHoursItem,
  EntityReferenceMediaWithTargetNodeLocationDetailFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeLocationDetailFieldParagraphsItem,
  ProductDbItemItem,
  NodeLocationDetail,
  ParsedNodeLocationDetail,
  EntityReferenceMediaWithTargetNodeLocationOverviewFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeLocationOverviewFieldParagraphsItem,
  EntityReferenceRevisionsParagraphWithTargetNodeLocationOverviewFieldParagraphsUpperItem,
  NodeLocationOverview,
  ParsedNodeLocationOverview,
  EntityReferenceMediaWithTargetNodeNewsItemFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeNewsItemFieldParagraphsItem,
  NodeNewsItem,
  ParsedNodeNewsItem,
  EntityReferenceMediaWithTargetNodeNewsOverviewFieldMediaItem,
  NodeNewsOverview,
  ParsedNodeNewsOverview,
  EntityReferenceMediaWithTargetNodeNewsletterFieldMediaItem,
  NodeNewsletter,
  ParsedNodeNewsletter,
  EntityReferenceMediaWithTargetNodePageFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodePageFieldParagraphsItem,
  NodePage,
  ParsedNodePage,
  EntityReferenceRevisionsParagraphWithTargetNodeReportFieldDatetimeItemsItem,
  EntityReferenceRevisionsParagraphWithTargetNodeReportFieldLocationItemsItem,
  EntityReferenceMediaWithTargetNodeReportFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeReportFieldParagraphsItem,
  NodeReport,
  ParsedNodeReport,
  EntityReferenceMediaWithTargetNodeReportOverviewFieldMediaItem,
  NodeReportOverview,
  ParsedNodeReportOverview,
  EntityReferenceMediaWithTargetNodeSectionsFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeSectionsFieldParagraphsItem,
  NodeSections,
  ParsedNodeSections,
  EntityReferenceMediaWithTargetNodeVacancyFieldMediaItem,
  EntityReferenceRevisionsParagraphWithTargetNodeVacancyFieldParagraphsItem,
  NodeVacancy,
  ParsedNodeVacancy,
  ParsedNode,
  EntityReferenceTaxonomyVocabularyItem,
  ParsedEntityReferenceTaxonomyVocabularyItem,
  TaxonomyTermBase,
  ParsedTaxonomyTermBase,
  TaxonomyTermArea,
  ParsedTaxonomyTermArea,
  TaxonomyTerm,
  TaxonomyTermBlogCategory,
  ParsedTaxonomyTermBlogCategory,
  TaxonomyTermChildcareType,
  ParsedTaxonomyTermChildcareType,
  TaxonomyTermTag,
  ParsedTaxonomyTermTag,
  TaxonomyTermVacancyCategory,
  ParsedTaxonomyTermVacancyCategory,
  ParsedTaxonomyTerm,
  InputEntity,
  ParsedInputEntity,
  ParsedEntity
} from './types'
import {
  Map,
  OrderedMap,
  List
} from 'immutable'
import * as Moment from 'moment'

export const noop_parser = <T>(t: T): T => t

export const language_links_parser = (l: LanguageLinks): ParsedLanguageLinks => Map<Language, string>(l)

export const entity_operation_parser = (t: EntityOperation): ParsedEntityOperation => ({
  title: t.title,
  url: t.url
})

export const entity_operations_parser = (l: EntityOperations | undefined): ParsedEntityOperations => l ? OrderedMap<string, EntityOperation>(l).sortBy(o => (o as EntityOperation).weight).map(o => entity_operation_parser(o as EntityOperation)).toOrderedMap() : OrderedMap<string, EntityOperation>()

export const integer_item_parser = (t: IntegerItem): number => noop_parser<number>(t.value)

export const singular_optional_integer_parser = (f: FieldItemList<IntegerItem>): number | null => f && f.length > 0 ? integer_item_parser(f[0]) : null

export const uuid_item_parser = (t: UuidItem): string => noop_parser<string>(t.value)

export const singular_optional_uuid_parser = (f: FieldItemList<UuidItem>): string | null => f && f.length > 0 ? uuid_item_parser(f[0]) : null

export const language_item_parser = (t: LanguageItem): Language => t.value

export const singular_optional_language_parser = (f: FieldItemList<LanguageItem>): Language | null => f && f.length > 0 ? language_item_parser(f[0]) : null

export const entity_reference_node_type_item_parser = (t: EntityReferenceNodeTypeItem): ParsedEntityReferenceNodeTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_node_type_parser = (f: FieldItemList<EntityReferenceNodeTypeItem>): ParsedEntityReferenceNodeTypeItem => entity_reference_node_type_item_parser(f[0])

export const node_bundle_parser = (f: FieldItemList<EntityReferenceNodeTypeItem>): string => f[0].target_id

export const moment_parser = (t: string): Moment.Moment => Moment.utc(t).local()

export const required_date_time_parser = (t: string): Moment.Moment => moment_parser(t)

export const timestamp_item_parser = (t: TimestampItem): Moment.Moment => required_date_time_parser(t.value)

export const singular_optional_created_parser = (f: FieldItemList<TimestampItem>): Moment.Moment | null => f && f.length > 0 ? timestamp_item_parser(f[0]) : null

export const entity_reference_user_item_parser = (t: EntityReferenceUserItem): ParsedEntityReferenceUserItem => ({
  id: noop_parser<number>(t.target_id),
  url: t.url,
  label: t.target_label
})

export const singular_optional_entity_reference_user_parser = (f: FieldItemList<EntityReferenceUserItem>): ParsedEntityReferenceUserItem | null => f && f.length > 0 ? entity_reference_user_item_parser(f[0]) : null

export const string_item_parser = (t: StringItem): string => noop_parser<string>(t.value)

export const singular_optional_string_long_parser = (f: FieldItemList<StringItem>): string | null => f && f.length > 0 ? string_item_parser(f[0]) : null

export const boolean_item_parser = (t: BooleanItem): boolean => noop_parser<boolean>(t.value)

export const singular_optional_boolean_parser = (f: FieldItemList<BooleanItem>): boolean | null => f && f.length > 0 ? boolean_item_parser(f[0]) : null

export const singular_required_string_parser = (f: FieldItemList<StringItem>): string => string_item_parser(f[0])

export const singular_optional_changed_parser = (f: FieldItemList<TimestampItem>): Moment.Moment | null => f && f.length > 0 ? timestamp_item_parser(f[0]) : null

export const singular_optional_string_parser = (f: FieldItemList<StringItem>): string | null => f && f.length > 0 ? string_item_parser(f[0]) : null

export const metatag_computed_item_parser = (t: MetatagComputedItem): ParsedMetatagComputedItem => ({
  tag: noop_parser<string>(t.tag),
  attributes: noop_parser<any>(t.attributes)
})

export const plural_metatag_computed_parser =
  (f: FieldItemList<MetatagComputedItem>): List<ParsedMetatagComputedItem> =>
    List<ParsedMetatagComputedItem>(f.map(i => metatag_computed_item_parser(i)))

export const path_item_parser = (t: PathItem): string | null => noop_parser<string | null>(t.alias)

export const singular_optional_path_parser = (f: FieldItemList<PathItem> | undefined): string | null => f && f.length > 0 ? path_item_parser(f[0]) : null

export const singular_optional_timestamp_parser = (f: FieldItemList<TimestampItem>): Moment.Moment | null => f && f.length > 0 ? timestamp_item_parser(f[0]) : null

export const list_string_item_parser = (t: ListStringItem): string => noop_parser<string>(t.value)

export const singular_optional_list_string_parser = (f: FieldItemList<ListStringItem>): string | null => f && f.length > 0 ? list_string_item_parser(f[0]) : null

export const node_base_parser = (t: NodeBase): ParsedNodeBase => ({
  entity_type: ((_: any): "node" => "node")(t),
  id: singular_optional_integer_parser(t.nid),
  status: singular_optional_boolean_parser(t.status),
  author: singular_optional_entity_reference_user_parser(t.uid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.title),
  revision_timestamp: singular_optional_created_parser(t.revision_timestamp),
  revision_uid: singular_optional_entity_reference_user_parser(t.revision_uid),
  revision_log: singular_optional_string_long_parser(t.revision_log),
  created: singular_optional_created_parser(t.created),
  changed: singular_optional_changed_parser(t.changed),
  promote: singular_optional_boolean_parser(t.promote),
  sticky: singular_optional_boolean_parser(t.sticky),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  moderation_state: singular_optional_string_parser(t.moderation_state),
  metatag: plural_metatag_computed_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  publish_on: singular_optional_timestamp_parser(t.publish_on),
  unpublish_on: singular_optional_timestamp_parser(t.unpublish_on),
  publish_state: singular_optional_list_string_parser(t.publish_state),
  unpublish_state: singular_optional_list_string_parser(t.unpublish_state),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const entity_reference_paragraphs_type_item_parser = (t: EntityReferenceParagraphsTypeItem): ParsedEntityReferenceParagraphsTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_paragraphs_type_parser = (f: FieldItemList<EntityReferenceParagraphsTypeItem>): ParsedEntityReferenceParagraphsTypeItem => entity_reference_paragraphs_type_item_parser(f[0])

export const paragraph_bundle_parser = (f: FieldItemList<EntityReferenceParagraphsTypeItem>): string => f[0].target_id

export const paragraph_base_parser = (t: ParagraphBase): ParsedParagraphBase => ({
  entity_type: ((_: any): "paragraph" => "paragraph")(t),
  id: singular_optional_integer_parser(t.id),
  language: singular_optional_language_parser(t.langcode),
  status: singular_optional_boolean_parser(t.status),
  created: singular_optional_created_parser(t.created),
  parent_id: singular_optional_string_parser(t.parent_id),
  parent_type: singular_optional_string_parser(t.parent_type),
  parent_field_name: singular_optional_string_parser(t.parent_field_name),
  behavior_settings: singular_optional_string_long_parser(t.behavior_settings),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const product_db_entity_item_parser = (t: ProductDbEntityItem): number => noop_parser<number>(t.target_id)

export const plural_product_db_entity_parser =
  (f: FieldItemList<ProductDbEntityItem>): List<number> =>
    List<number>(f.map(i => product_db_entity_item_parser(i)))

export const list_integer_item_parser = (t: ListIntegerItem): number => noop_parser<number>(t.value)

export const singular_optional_list_integer_parser = (f: FieldItemList<ListIntegerItem>): number | null => f && f.length > 0 ? list_integer_item_parser(f[0]) : null

export const paragraph_activity_cluster_parser = (t: ParagraphActivityCluster): ParsedParagraphActivityCluster => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "activity_cluster" => "activity_cluster")(t.type),
  field_product_db_ids: plural_product_db_entity_parser(t.field_product_db_ids),
  field_row_count: singular_optional_list_integer_parser(t.field_row_count),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_activity_cluster_guard = (t: Paragraph): t is ParagraphActivityCluster => paragraph_bundle_parser(t.type) == "activity_cluster"

export const entity_reference_media_type_item_parser = (t: EntityReferenceMediaTypeItem): ParsedEntityReferenceMediaTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_media_type_parser = (f: FieldItemList<EntityReferenceMediaTypeItem>): ParsedEntityReferenceMediaTypeItem => entity_reference_media_type_item_parser(f[0])

export const media_bundle_parser = (f: FieldItemList<EntityReferenceMediaTypeItem>): string => f[0].target_id

export const file_uri_item_parser = (t: FileUriItem): string | null => noop_parser<string | null>(t.url)

export const singular_optional_file_uri_parser = (f: FieldItemList<FileUriItem>): string | null => f && f.length > 0 ? file_uri_item_parser(f[0]) : null

export const file_base_parser = (t: FileBase): ParsedFileBase => ({
  entity_type: ((_: any): "file" => "file")(t),
  id: singular_optional_integer_parser(t.fid),
  label: singular_optional_string_parser(t.filename),
  url: singular_optional_file_uri_parser(t.uri)
})

export const styles_parser = (t: Styles): ParsedStyles => ({
  "1080x900": t["1080x900"],
  "1173w": t["1173w"],
  "1200x900": t["1200x900"],
  "1248x848": t["1248x848"],
  "1280w": t["1280w"],
  "1280x720": t["1280x720"],
  "1564w": t["1564w"],
  "1600w": t["1600w"],
  "1880x1880": t["1880x1880"],
  "195w": t["195w"],
  "195x195": t["195x195"],
  "200x140": t["200x140"],
  "2496x1696": t["2496x1696"],
  "300x210": t["300x210"],
  "300x300": t["300x300"],
  "360x300": t["360x300"],
  "380h": t["380h"],
  "390h": t["390h"],
  "390w": t["390w"],
  "390x390": t["390x390"],
  "391w": t["391w"],
  "400w": t["400w"],
  "400x280": t["400x280"],
  "420x320": t["420x320"],
  "420x320_cropped": t["420x320_cropped"],
  "440x440": t["440x440"],
  "448x448": t["448x448"],
  "470x470": t["470x470"],
  "478x478": t["478x478"],
  "600x420": t["600x420"],
  "600x600": t["600x600"],
  "624x424": t["624x424"],
  "720x600": t["720x600"],
  "782w": t["782w"],
  "790w": t["790w"],
  "790x445": t["790x445"],
  "800w": t["800w"],
  "800x560": t["800x560"],
  "840x640": t["840x640"],
  "840x640_cropped": t["840x640_cropped"],
  "880x880": t["880x880"],
  "896x896": t["896x896"],
  "940x940": t["940x940"],
  "956x956": t["956x956"],
  crop_thumbnail: t.crop_thumbnail,
  large: t.large,
  medium: t.medium,
  thumbnail: t.thumbnail
})

export const file_image_parser = (t: FileImage): ParsedFileImage => ({
  ...file_base_parser(t),
  style_urls: (t.style_urls !== undefined ? styles_parser(t.style_urls) : undefined)
})

export const file_image_guard = (t:File): t is FileImage => (t as any).style_urls !== undefined

export const file_other_parser = (t: FileOther): ParsedFileOther => ({
  ...file_base_parser(t)
})

export const file_other_guard = (t:File): t is FileOther => (t as any).style_urls === undefined

export const file_parser = (t: File): ParsedFile => file_image_guard(t) ? file_image_parser(t) : file_other_parser(t)

export const file_guard = (t: Entity): t is File => (
  (t as any).fid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).filename !== undefined &&
  (t as any).uri !== undefined &&
  (t as any).filemime !== undefined &&
  (t as any).filesize !== undefined &&
  (t as any).status !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined
)

export const image_file_with_target_item_parser = (t: ImageFileWithTargetItem): ParsedImageFileWithTargetItem => ({
  alt: noop_parser<string | null>(t.alt),
  image: (t.target !== undefined ? file_image_parser(t.target) : undefined)
})

export const image_file_with_target_item_guard = (t: any): t is ImageFileWithTargetItem => (t.target_id !== undefined) && (t.alt !== undefined) && (t.title !== undefined) && (t.width !== undefined) && (t.height !== undefined) && ((t.target === undefined) || file_image_guard(t.target))

export const singular_optional_image_file_with_target_parser = (f: FieldItemList<ImageFileWithTargetItem>): ParsedImageFileWithTargetItem | null => f && f.length > 0 && image_file_with_target_item_guard(f[0]) ? image_file_with_target_item_parser(f[0]) : null

export const media_base_parser = (t: MediaBase): ParsedMediaBase => ({
  entity_type: ((_: any): "media" => "media")(t),
  id: singular_optional_integer_parser(t.mid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.name),
  revision_created: singular_optional_created_parser(t.revision_created),
  revision_user: singular_optional_entity_reference_user_parser(t.revision_user),
  revision_log_message: singular_optional_string_long_parser(t.revision_log_message),
  status: singular_optional_boolean_parser(t.status),
  uid: singular_optional_entity_reference_user_parser(t.uid),
  thumbnail: singular_optional_image_file_with_target_parser(t.thumbnail),
  created: singular_optional_created_parser(t.created),
  changed: singular_optional_changed_parser(t.changed),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  metatag: plural_metatag_computed_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  publish_on: singular_optional_timestamp_parser(t.publish_on),
  unpublish_on: singular_optional_timestamp_parser(t.unpublish_on),
  publish_state: singular_optional_list_string_parser(t.publish_state),
  unpublish_state: singular_optional_list_string_parser(t.unpublish_state),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const file_file_with_target_item_parser = (t: FileFileWithTargetItem): ParsedFileFileWithTargetItem => ({
  description: noop_parser<string | null>(t.description),
  file: (t.target !== undefined ? file_other_parser(t.target) : undefined)
})

export const file_file_with_target_item_guard = (t: any): t is FileFileWithTargetItem => (t.target_id !== undefined) && (t.display !== undefined) && (t.description !== undefined) && ((t.target === undefined) || file_other_guard(t.target))

export const singular_required_file_file_with_target_parser = (f: FieldItemList<FileFileWithTargetItem>): ParsedFileFileWithTargetItem => file_file_with_target_item_parser(f[0])

export const media_document_parser = (t: MediaDocument): ParsedMediaDocument => ({
  ...media_base_parser(t),
  bundle: ((_: any): "document" => "document")(t.bundle),
  field_media_file: singular_required_file_file_with_target_parser(t.field_media_file)
})

export const media_document_guard = (t: Media): t is MediaDocument => media_bundle_parser(t.bundle) == "document"

export const singular_required_image_file_with_target_parser = (f: FieldItemList<ImageFileWithTargetItem>): ParsedImageFileWithTargetItem => image_file_with_target_item_parser(f[0])

export const media_image_parser = (t: MediaImage): ParsedMediaImage => ({
  ...media_base_parser(t),
  bundle: ((_: any): "image" => "image")(t.bundle),
  field_media_image: singular_required_image_file_with_target_parser(t.field_media_image)
})

export const media_image_guard = (t: Media): t is MediaImage => media_bundle_parser(t.bundle) == "image"

export const video_embed_field_item_parser = (t: VideoEmbedFieldItem): ParsedVideoEmbedFieldItem => ({
  type: t.video_type,
  id: t.video_id,
  iframe_url: t.iframe_url
})

export const singular_required_video_embed_field_parser = (f: FieldItemList<VideoEmbedFieldItem>): ParsedVideoEmbedFieldItem => video_embed_field_item_parser(f[0])

export const media_video_parser = (t: MediaVideo): ParsedMediaVideo => ({
  ...media_base_parser(t),
  bundle: ((_: any): "video" => "video")(t.bundle),
  field_media_video_embed_field: singular_required_video_embed_field_parser(t.field_media_video_embed_field)
})

export const media_video_guard = (t: Media): t is MediaVideo => media_bundle_parser(t.bundle) == "video"

export const media_parser = (t: Media): ParsedMedia =>
  media_document_guard(t) ?
    media_document_parser(t) :
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t)

export const media_guard = (t: Entity): t is Media => (
  (t as any).mid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).bundle !== undefined &&
  (t as any).bundle[0].target_type == "media_type" &&
  (t as any).revision_created !== undefined &&
  (t as any).revision_user !== undefined &&
  (t as any).revision_log_message !== undefined &&
  (t as any).status !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).name !== undefined &&
  (t as any).thumbnail !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).metatag !== undefined &&
  (t as any).publish_on !== undefined &&
  (t as any).unpublish_on !== undefined &&
  (t as any).publish_state !== undefined &&
  (t as any).unpublish_state !== undefined
)

export const entity_reference_media_with_target_paragraph_book_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphBookFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_book_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphBookFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_book_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphBookFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_book_field_image_item_parser(f[0])

export const link_item_parser = (t: LinkItem): ParsedLinkItem => ({
  title: noop_parser<string | null>(t.title),
  url: t.processed_url
})

export const singular_required_link_parser = (f: FieldItemList<LinkItem>): ParsedLinkItem => link_item_parser(f[0])

export const paragraph_book_parser = (t: ParagraphBook): ParsedParagraphBook => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "book" => "book")(t.type),
  field_author: singular_required_string_parser(t.field_author),
  field_image: singular_required_entity_reference_media_with_target_paragraph_book_field_image_parser(t.field_image),
  field_link: singular_required_link_parser(t.field_link),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_book_guard = (t: Paragraph): t is ParagraphBook => paragraph_bundle_parser(t.type) == "book"

export const entity_reference_revisions_paragraph_with_target_paragraph_books_field_books_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphBooksFieldBooksItem): ParsedParagraphBook | undefined | undefined => (t.target !== undefined ? ((t: ParagraphBook): ParsedParagraphBook =>
    paragraph_book_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_books_field_books_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphBooksFieldBooksItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_books_field_books_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphBooksFieldBooksItem>): List<ParsedParagraphBook> =>
    List<ParsedParagraphBook>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_books_field_books_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_books_field_books_item_parser(i)).filter(i => i !== undefined))

export const paragraph_books_parser = (t: ParagraphBooks): ParsedParagraphBooks => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "books" => "books")(t.type),
  field_books: plural_entity_reference_revisions_paragraph_with_target_paragraph_books_field_books_parser(t.field_books),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_books_guard = (t: Paragraph): t is ParagraphBooks => paragraph_bundle_parser(t.type) == "books"

export const entity_reference_revisions_paragraph_with_target_paragraph_caroussel_field_content_grid_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphCarousselFieldContentGridItemsItem): ParsedParagraphContentGridVideo | ParsedParagraphContentGridItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphContentGridVideo | ParagraphContentGridItem): ParsedParagraphContentGridVideo | ParsedParagraphContentGridItem =>
  paragraph_content_grid_video_guard(t) ?
    paragraph_content_grid_video_parser(t) :
    paragraph_content_grid_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_caroussel_field_content_grid_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphCarousselFieldContentGridItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_caroussel_field_content_grid_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphCarousselFieldContentGridItemsItem>): List<ParsedParagraphContentGridVideo | ParsedParagraphContentGridItem> =>
    List<ParsedParagraphContentGridVideo | ParsedParagraphContentGridItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_caroussel_field_content_grid_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_caroussel_field_content_grid_items_item_parser(i)).filter(i => i !== undefined))

export const singular_optional_link_parser = (f: FieldItemList<LinkItem>): ParsedLinkItem | null => f && f.length > 0 ? link_item_parser(f[0]) : null

export const paragraph_caroussel_parser = (t: ParagraphCaroussel): ParsedParagraphCaroussel => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "caroussel" => "caroussel")(t.type),
  field_content_grid_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_caroussel_field_content_grid_items_parser(t.field_content_grid_items),
  field_primary_action: singular_optional_link_parser(t.field_primary_action),
  field_row_count: singular_optional_list_integer_parser(t.field_row_count),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_caroussel_guard = (t: Paragraph): t is ParagraphCaroussel => paragraph_bundle_parser(t.type) == "caroussel"

export const entity_reference_revisions_paragraph_with_target_paragraph_collection_field_collection_groups_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphCollectionFieldCollectionGroupsItem): ParsedParagraphCollectionGroup | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCollectionGroup): ParsedParagraphCollectionGroup =>
    paragraph_collection_group_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_collection_field_collection_groups_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphCollectionFieldCollectionGroupsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_collection_field_collection_groups_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphCollectionFieldCollectionGroupsItem>): List<ParsedParagraphCollectionGroup> =>
    List<ParsedParagraphCollectionGroup>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_collection_field_collection_groups_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_collection_field_collection_groups_item_parser(i)).filter(i => i !== undefined))

export const text_item_parser = (t: TextItem): string => t.processed

export const singular_optional_text_long_parser = (f: FieldItemList<TextItem>): string | null => f && f.length > 0 ? text_item_parser(f[0]) : null

export const paragraph_collection_parser = (t: ParagraphCollection): ParsedParagraphCollection => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "collection" => "collection")(t.type),
  field_collection_groups: plural_entity_reference_revisions_paragraph_with_target_paragraph_collection_field_collection_groups_parser(t.field_collection_groups),
  field_display_quick_links: singular_optional_boolean_parser(t.field_display_quick_links),
  field_rich_text: singular_optional_text_long_parser(t.field_rich_text),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_collection_guard = (t: Paragraph): t is ParagraphCollection => paragraph_bundle_parser(t.type) == "collection"

export const entity_reference_revisions_paragraph_with_target_paragraph_collection_group_field_collection_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphCollectionGroupFieldCollectionItemsItem): ParsedParagraphCollectionItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCollectionItem): ParsedParagraphCollectionItem =>
    paragraph_collection_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_collection_group_field_collection_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphCollectionGroupFieldCollectionItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_collection_group_field_collection_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphCollectionGroupFieldCollectionItemsItem>): List<ParsedParagraphCollectionItem> =>
    List<ParsedParagraphCollectionItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_collection_group_field_collection_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_collection_group_field_collection_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_collection_group_parser = (t: ParagraphCollectionGroup): ParsedParagraphCollectionGroup => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "collection_group" => "collection_group")(t.type),
  field_collection_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_collection_group_field_collection_items_parser(t.field_collection_items),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_collection_group_guard = (t: Paragraph): t is ParagraphCollectionGroup => paragraph_bundle_parser(t.type) == "collection_group"

export const singular_required_list_string_parser = (f: FieldItemList<ListStringItem>): string => list_string_item_parser(f[0])

export const singular_required_string_long_parser = (f: FieldItemList<StringItem>): string => string_item_parser(f[0])

export const paragraph_collection_item_parser = (t: ParagraphCollectionItem): ParsedParagraphCollectionItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "collection_item" => "collection_item")(t.type),
  field_icon: singular_required_list_string_parser(t.field_icon),
  field_link: singular_required_link_parser(t.field_link),
  field_subtitle: singular_optional_string_parser(t.field_subtitle),
  field_text: singular_required_string_long_parser(t.field_text),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_collection_item_guard = (t: Paragraph): t is ParagraphCollectionItem => paragraph_bundle_parser(t.type) == "collection_item"

export const paragraph_collection_search_bar_parser = (t: ParagraphCollectionSearchBar): ParsedParagraphCollectionSearchBar => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "collection_search_bar" => "collection_search_bar")(t.type)
})

export const paragraph_collection_search_bar_guard = (t: Paragraph): t is ParagraphCollectionSearchBar => paragraph_bundle_parser(t.type) == "collection_search_bar"

export const entity_reference_revisions_paragraph_with_target_paragraph_content_grid_field_content_grid_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphContentGridFieldContentGridItemsItem): ParsedParagraphContentGridItem | ParsedParagraphContentGridVideo | undefined | undefined => (t.target !== undefined ? ((t: ParagraphContentGridItem | ParagraphContentGridVideo): ParsedParagraphContentGridItem | ParsedParagraphContentGridVideo =>
  paragraph_content_grid_item_guard(t) ?
    paragraph_content_grid_item_parser(t) :
    paragraph_content_grid_video_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_content_grid_field_content_grid_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphContentGridFieldContentGridItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_content_grid_field_content_grid_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphContentGridFieldContentGridItemsItem>): List<ParsedParagraphContentGridItem | ParsedParagraphContentGridVideo> =>
    List<ParsedParagraphContentGridItem | ParsedParagraphContentGridVideo>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_content_grid_field_content_grid_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_content_grid_field_content_grid_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_content_grid_parser = (t: ParagraphContentGrid): ParsedParagraphContentGrid => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "content_grid" => "content_grid")(t.type),
  field_content_grid_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_content_grid_field_content_grid_items_parser(t.field_content_grid_items),
  field_row_count: singular_optional_list_integer_parser(t.field_row_count)
})

export const paragraph_content_grid_guard = (t: Paragraph): t is ParagraphContentGrid => paragraph_bundle_parser(t.type) == "content_grid"

export const entity_reference_media_with_target_paragraph_content_grid_item_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphContentGridItemFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_content_grid_item_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphContentGridItemFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_content_grid_item_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphContentGridItemFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_content_grid_item_field_image_item_parser(f[0])

export const paragraph_content_grid_item_parser = (t: ParagraphContentGridItem): ParsedParagraphContentGridItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "content_grid_item" => "content_grid_item")(t.type),
  field_image: singular_required_entity_reference_media_with_target_paragraph_content_grid_item_field_image_parser(t.field_image),
  field_label: singular_optional_string_parser(t.field_label),
  field_link: singular_required_link_parser(t.field_link),
  field_subtitle: singular_optional_string_parser(t.field_subtitle),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_content_grid_item_guard = (t: Paragraph): t is ParagraphContentGridItem => paragraph_bundle_parser(t.type) == "content_grid_item"

export const paragraph_content_grid_video_parser = (t: ParagraphContentGridVideo): ParsedParagraphContentGridVideo => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "content_grid_video" => "content_grid_video")(t.type),
  field_label: singular_optional_string_parser(t.field_label),
  field_link: singular_required_link_parser(t.field_link),
  field_subtitle: singular_optional_string_parser(t.field_subtitle),
  field_title: singular_required_string_parser(t.field_title),
  field_video: singular_required_video_embed_field_parser(t.field_video)
})

export const paragraph_content_grid_video_guard = (t: Paragraph): t is ParagraphContentGridVideo => paragraph_bundle_parser(t.type) == "content_grid_video"

export const singular_required_integer_parser = (f: FieldItemList<IntegerItem>): number => integer_item_parser(f[0])

export const entity_reference_media_with_target_paragraph_core_activity_cluster_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphCoreActivityClusterFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_core_activity_cluster_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphCoreActivityClusterFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_core_activity_cluster_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphCoreActivityClusterFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_core_activity_cluster_field_image_item_parser(f[0])

export const paragraph_core_activity_cluster_parser = (t: ParagraphCoreActivityCluster): ParsedParagraphCoreActivityCluster => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "core_activity_cluster" => "core_activity_cluster")(t.type),
  field_activity_cluster_id: singular_required_integer_parser(t.field_activity_cluster_id),
  field_image: singular_required_entity_reference_media_with_target_paragraph_core_activity_cluster_field_image_parser(t.field_image),
  field_link: singular_required_link_parser(t.field_link),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_core_activity_cluster_guard = (t: Paragraph): t is ParagraphCoreActivityCluster => paragraph_bundle_parser(t.type) == "core_activity_cluster"

export const paragraph_cta_block_parser = (t: ParagraphCtaBlock): ParsedParagraphCtaBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "cta_block" => "cta_block")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_primary_action: singular_required_link_parser(t.field_primary_action),
  field_secondary_action: singular_optional_link_parser(t.field_secondary_action),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_cta_block_guard = (t: Paragraph): t is ParagraphCtaBlock => paragraph_bundle_parser(t.type) == "cta_block"

export const singular_required_timestamp_parser = (f: FieldItemList<TimestampItem>): Moment.Moment => timestamp_item_parser(f[0])

export const paragraph_datetime_parser = (t: ParagraphDatetime): ParsedParagraphDatetime => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "datetime" => "datetime")(t.type),
  field_datetime: singular_required_timestamp_parser(t.field_datetime)
})

export const paragraph_datetime_guard = (t: Paragraph): t is ParagraphDatetime => paragraph_bundle_parser(t.type) == "datetime"

export const singular_required_text_long_parser = (f: FieldItemList<TextItem>): string => text_item_parser(f[0])

export const paragraph_expander_item_parser = (t: ParagraphExpanderItem): ParsedParagraphExpanderItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "expander_item" => "expander_item")(t.type),
  field_rich_text: singular_required_text_long_parser(t.field_rich_text),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_expander_item_guard = (t: Paragraph): t is ParagraphExpanderItem => paragraph_bundle_parser(t.type) == "expander_item"

export const entity_reference_revisions_paragraph_with_target_paragraph_expanders_field_expander_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphExpandersFieldExpanderItemsItem): ParsedParagraphExpanderItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphExpanderItem): ParsedParagraphExpanderItem =>
    paragraph_expander_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_expanders_field_expander_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphExpandersFieldExpanderItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_expanders_field_expander_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphExpandersFieldExpanderItemsItem>): List<ParsedParagraphExpanderItem> =>
    List<ParsedParagraphExpanderItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_expanders_field_expander_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_expanders_field_expander_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_expanders_parser = (t: ParagraphExpanders): ParsedParagraphExpanders => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "expanders" => "expanders")(t.type),
  field_expander_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_expanders_field_expander_items_parser(t.field_expander_items),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_expanders_guard = (t: Paragraph): t is ParagraphExpanders => paragraph_bundle_parser(t.type) == "expanders"

export const entity_reference_node_with_target_paragraph_faq_collection_field_faq_item_item_parser = (t: EntityReferenceNodeWithTargetParagraphFaqCollectionFieldFaqItemItem): ParsedNodeFaq | undefined | undefined => (t.target !== undefined ? ((t: NodeFaq): ParsedNodeFaq =>
    node_faq_parser(t))(t.target) : undefined)

export const entity_reference_node_with_target_paragraph_faq_collection_field_faq_item_item_guard = (t: any): t is EntityReferenceNodeWithTargetParagraphFaqCollectionFieldFaqItemItem => (t.target_id !== undefined)

export const plural_entity_reference_node_with_target_paragraph_faq_collection_field_faq_item_parser =
  (f: FieldItemList<EntityReferenceNodeWithTargetParagraphFaqCollectionFieldFaqItemItem>): List<ParsedNodeFaq> =>
    List<ParsedNodeFaq>(f.filter(i => entity_reference_node_with_target_paragraph_faq_collection_field_faq_item_item_guard(i)).map(i => entity_reference_node_with_target_paragraph_faq_collection_field_faq_item_item_parser(i)).filter(i => i !== undefined))

export const paragraph_faq_collection_parser = (t: ParagraphFaqCollection): ParsedParagraphFaqCollection => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "faq_collection" => "faq_collection")(t.type),
  field_faq_item: plural_entity_reference_node_with_target_paragraph_faq_collection_field_faq_item_parser(t.field_faq_item),
  field_faq_title: singular_required_string_parser(t.field_faq_title)
})

export const paragraph_faq_collection_guard = (t: Paragraph): t is ParagraphFaqCollection => paragraph_bundle_parser(t.type) == "faq_collection"

export const entity_reference_media_with_target_paragraph_featured_content_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphFeaturedContentFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_featured_content_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphFeaturedContentFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_featured_content_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphFeaturedContentFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_featured_content_field_image_item_parser(f[0])

export const paragraph_featured_content_parser = (t: ParagraphFeaturedContent): ParsedParagraphFeaturedContent => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "featured_content" => "featured_content")(t.type),
  field_image: singular_required_entity_reference_media_with_target_paragraph_featured_content_field_image_parser(t.field_image),
  field_link: singular_required_link_parser(t.field_link),
  field_rich_text: singular_required_text_long_parser(t.field_rich_text),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_featured_content_guard = (t: Paragraph): t is ParagraphFeaturedContent => paragraph_bundle_parser(t.type) == "featured_content"

export const paragraph_formstack_block_parser = (t: ParagraphFormstackBlock): ParsedParagraphFormstackBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "formstack_block" => "formstack_block")(t.type),
  field_formstack_form_id: singular_required_string_parser(t.field_formstack_form_id)
})

export const paragraph_formstack_block_guard = (t: Paragraph): t is ParagraphFormstackBlock => paragraph_bundle_parser(t.type) == "formstack_block"

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_block_field_grid_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphGridBlockFieldGridItemsItem): ParsedParagraphGridItems | undefined | undefined => (t.target !== undefined ? ((t: ParagraphGridItems): ParsedParagraphGridItems =>
    paragraph_grid_items_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_block_field_grid_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphGridBlockFieldGridItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_block_field_grid_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphGridBlockFieldGridItemsItem>): List<ParsedParagraphGridItems> =>
    List<ParsedParagraphGridItems>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_block_field_grid_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_block_field_grid_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_grid_block_parser = (t: ParagraphGridBlock): ParsedParagraphGridBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_block" => "grid_block")(t.type),
  field_title: singular_optional_string_parser(t.field_title),
  field_grid_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_block_field_grid_items_parser(t.field_grid_items),
  field_row_count: singular_optional_list_integer_parser(t.field_row_count)
})

export const paragraph_grid_block_guard = (t: Paragraph): t is ParagraphGridBlock => paragraph_bundle_parser(t.type) == "grid_block"

export const entity_reference_media_with_target_paragraph_grid_items_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphGridItemsFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_grid_items_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphGridItemsFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_grid_items_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphGridItemsFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_grid_items_field_media_item_parser(f[0])

export const paragraph_grid_items_parser = (t: ParagraphGridItems): ParsedParagraphGridItems => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_items" => "grid_items")(t.type),
  field_link: singular_required_link_parser(t.field_link),
  field_media: singular_required_entity_reference_media_with_target_paragraph_grid_items_field_media_parser(t.field_media),
  field_text: singular_required_string_long_parser(t.field_text),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_grid_items_guard = (t: Paragraph): t is ParagraphGridItems => paragraph_bundle_parser(t.type) == "grid_items"

export const paragraph_highlight_parser = (t: ParagraphHighlight): ParsedParagraphHighlight => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "highlight" => "highlight")(t.type),
  field_rich_text: singular_required_text_long_parser(t.field_rich_text),
  field_subtitle: singular_required_string_parser(t.field_subtitle),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_highlight_guard = (t: Paragraph): t is ParagraphHighlight => paragraph_bundle_parser(t.type) == "highlight"

export const paragraph_iframe_parser = (t: ParagraphIframe): ParsedParagraphIframe => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "iframe" => "iframe")(t.type),
  field_link: singular_required_link_parser(t.field_link)
})

export const paragraph_iframe_guard = (t: Paragraph): t is ParagraphIframe => paragraph_bundle_parser(t.type) == "iframe"

export const entity_reference_media_with_target_paragraph_images_field_images_item_parser = (t: EntityReferenceMediaWithTargetParagraphImagesFieldImagesItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_images_field_images_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphImagesFieldImagesItem => (t.target_id !== undefined)

export const plural_entity_reference_media_with_target_paragraph_images_field_images_parser =
  (f: FieldItemList<EntityReferenceMediaWithTargetParagraphImagesFieldImagesItem>): List<ParsedMediaImage> =>
    List<ParsedMediaImage>(f.filter(i => entity_reference_media_with_target_paragraph_images_field_images_item_guard(i)).map(i => entity_reference_media_with_target_paragraph_images_field_images_item_parser(i)).filter(i => i !== undefined))

export const paragraph_images_parser = (t: ParagraphImages): ParsedParagraphImages => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "images" => "images")(t.type),
  field_images: plural_entity_reference_media_with_target_paragraph_images_field_images_parser(t.field_images)
})

export const paragraph_images_guard = (t: Paragraph): t is ParagraphImages => paragraph_bundle_parser(t.type) == "images"

export const entity_reference_media_with_target_paragraph_inline_media_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphInlineMediaFieldMediaItem): ParsedMediaImage | ParsedMediaVideo | undefined | undefined => (t.target !== undefined ? ((t: MediaImage | MediaVideo): ParsedMediaImage | ParsedMediaVideo =>
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_inline_media_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphInlineMediaFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_inline_media_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphInlineMediaFieldMediaItem>): ParsedMediaImage | ParsedMediaVideo | undefined => entity_reference_media_with_target_paragraph_inline_media_field_media_item_parser(f[0])

export const paragraph_inline_media_parser = (t: ParagraphInlineMedia): ParsedParagraphInlineMedia => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "inline_media" => "inline_media")(t.type),
  field_media: singular_required_entity_reference_media_with_target_paragraph_inline_media_field_media_parser(t.field_media),
  field_media_display: singular_optional_list_string_parser(t.field_media_display),
  field_position: singular_required_list_string_parser(t.field_position)
})

export const paragraph_inline_media_guard = (t: Paragraph): t is ParagraphInlineMedia => paragraph_bundle_parser(t.type) == "inline_media"

export const paragraph_knop_parser = (t: ParagraphKnop): ParsedParagraphKnop => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "knop" => "knop")(t.type),
  field_link: singular_required_link_parser(t.field_link)
})

export const paragraph_knop_guard = (t: Paragraph): t is ParagraphKnop => paragraph_bundle_parser(t.type) == "knop"

export const paragraph_location_parser = (t: ParagraphLocation): ParsedParagraphLocation => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "location" => "location")(t.type),
  field_location: singular_optional_string_parser(t.field_location)
})

export const paragraph_location_guard = (t: Paragraph): t is ParagraphLocation => paragraph_bundle_parser(t.type) == "location"

export const entity_reference_media_with_target_paragraph_media_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphMediaFieldMediaItem): ParsedMediaImage | ParsedMediaVideo | undefined | undefined => (t.target !== undefined ? ((t: MediaImage | MediaVideo): ParsedMediaImage | ParsedMediaVideo =>
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_media_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphMediaFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_media_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphMediaFieldMediaItem>): ParsedMediaImage | ParsedMediaVideo | undefined => entity_reference_media_with_target_paragraph_media_field_media_item_parser(f[0])

export const paragraph_media_parser = (t: ParagraphMedia): ParsedParagraphMedia => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media" => "media")(t.type),
  field_media: singular_required_entity_reference_media_with_target_paragraph_media_field_media_parser(t.field_media)
})

export const paragraph_media_guard = (t: Paragraph): t is ParagraphMedia => paragraph_bundle_parser(t.type) == "media"

export const paragraph_newsletter_signup_form_parser = (t: ParagraphNewsletterSignupForm): ParsedParagraphNewsletterSignupForm => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "newsletter_signup_form" => "newsletter_signup_form")(t.type)
})

export const paragraph_newsletter_signup_form_guard = (t: Paragraph): t is ParagraphNewsletterSignupForm => paragraph_bundle_parser(t.type) == "newsletter_signup_form"

export const paragraph_opening_hours_parser = (t: ParagraphOpeningHours): ParsedParagraphOpeningHours => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "opening_hours" => "opening_hours")(t.type),
  field_additional_information: singular_optional_string_parser(t.field_additional_information),
  field_closed: singular_optional_boolean_parser(t.field_closed),
  field_closing_time: singular_optional_string_parser(t.field_closing_time),
  field_day: singular_required_list_string_parser(t.field_day),
  field_opening_time: singular_optional_string_parser(t.field_opening_time)
})

export const paragraph_opening_hours_guard = (t: Paragraph): t is ParagraphOpeningHours => paragraph_bundle_parser(t.type) == "opening_hours"

export const entity_reference_node_item_parser = (t: EntityReferenceNodeItem): ParsedEntityReferenceNodeItem => ({
  id: noop_parser<number>(t.target_id),
  url: t.url,
  label: t.target_label
})

export const plural_entity_reference_node_parser =
  (f: FieldItemList<EntityReferenceNodeItem>): List<ParsedEntityReferenceNodeItem> =>
    List<ParsedEntityReferenceNodeItem>(f.map(i => entity_reference_node_item_parser(i)))

export const paragraph_page_grid_parser = (t: ParagraphPageGrid): ParsedParagraphPageGrid => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "page_grid" => "page_grid")(t.type),
  field_page_grid_items: plural_entity_reference_node_parser(t.field_page_grid_items),
  field_primary_action: singular_optional_link_parser(t.field_primary_action),
  field_row_count: singular_optional_list_integer_parser(t.field_row_count),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_page_grid_guard = (t: Paragraph): t is ParagraphPageGrid => paragraph_bundle_parser(t.type) == "page_grid"

export const entity_reference_media_with_target_paragraph_panorama_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphPanoramaFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_panorama_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphPanoramaFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_panorama_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphPanoramaFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_panorama_field_image_item_parser(f[0])

export const paragraph_panorama_parser = (t: ParagraphPanorama): ParsedParagraphPanorama => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "panorama" => "panorama")(t.type),
  field_image: singular_required_entity_reference_media_with_target_paragraph_panorama_field_image_parser(t.field_image)
})

export const paragraph_panorama_guard = (t: Paragraph): t is ParagraphPanorama => paragraph_bundle_parser(t.type) == "panorama"

export const paragraph_quote_parser = (t: ParagraphQuote): ParsedParagraphQuote => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "quote" => "quote")(t.type),
  field_quote_source: singular_optional_string_parser(t.field_quote_source),
  field_quote_text: singular_required_string_long_parser(t.field_quote_text)
})

export const paragraph_quote_guard = (t: Paragraph): t is ParagraphQuote => paragraph_bundle_parser(t.type) == "quote"

export const paragraph_recent_news_parser = (t: ParagraphRecentNews): ParsedParagraphRecentNews => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "recent_news" => "recent_news")(t.type),
  field_count: singular_required_integer_parser(t.field_count),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_recent_news_guard = (t: Paragraph): t is ParagraphRecentNews => paragraph_bundle_parser(t.type) == "recent_news"

export const entity_reference_revisions_paragraph_with_target_paragraph_submenu_field_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphSubmenuFieldItemsItem): ParsedParagraphSubmenuItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphSubmenuItem): ParsedParagraphSubmenuItem =>
    paragraph_submenu_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_submenu_field_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphSubmenuFieldItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_submenu_field_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphSubmenuFieldItemsItem>): List<ParsedParagraphSubmenuItem> =>
    List<ParsedParagraphSubmenuItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_submenu_field_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_submenu_field_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_submenu_parser = (t: ParagraphSubmenu): ParsedParagraphSubmenu => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "submenu" => "submenu")(t.type),
  field_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_submenu_field_items_parser(t.field_items),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_submenu_guard = (t: Paragraph): t is ParagraphSubmenu => paragraph_bundle_parser(t.type) == "submenu"

export const paragraph_submenu_item_parser = (t: ParagraphSubmenuItem): ParsedParagraphSubmenuItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "submenu_item" => "submenu_item")(t.type),
  field_link: singular_required_link_parser(t.field_link)
})

export const paragraph_submenu_item_guard = (t: Paragraph): t is ParagraphSubmenuItem => paragraph_bundle_parser(t.type) == "submenu_item"

export const entity_reference_revisions_paragraph_with_target_paragraph_subscription_block_field_subscription_item_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphSubscriptionBlockFieldSubscriptionItemItem): ParsedParagraphSubscriptions | undefined | undefined => (t.target !== undefined ? ((t: ParagraphSubscriptions): ParsedParagraphSubscriptions =>
    paragraph_subscriptions_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_subscription_block_field_subscription_item_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphSubscriptionBlockFieldSubscriptionItemItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_subscription_block_field_subscription_item_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphSubscriptionBlockFieldSubscriptionItemItem>): List<ParsedParagraphSubscriptions> =>
    List<ParsedParagraphSubscriptions>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_subscription_block_field_subscription_item_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_subscription_block_field_subscription_item_item_parser(i)).filter(i => i !== undefined))

export const paragraph_subscription_block_parser = (t: ParagraphSubscriptionBlock): ParsedParagraphSubscriptionBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "subscription_block" => "subscription_block")(t.type),
  field_rich_text: singular_optional_text_long_parser(t.field_rich_text),
  field_subscription_item: plural_entity_reference_revisions_paragraph_with_target_paragraph_subscription_block_field_subscription_item_parser(t.field_subscription_item),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_subscription_block_guard = (t: Paragraph): t is ParagraphSubscriptionBlock => paragraph_bundle_parser(t.type) == "subscription_block"

export const paragraph_subscriptions_parser = (t: ParagraphSubscriptions): ParsedParagraphSubscriptions => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "subscriptions" => "subscriptions")(t.type),
  field_is_youth: singular_optional_boolean_parser(t.field_is_youth),
  field_link: singular_required_link_parser(t.field_link),
  field_materials: singular_required_text_long_parser(t.field_materials),
  field_price: singular_required_string_parser(t.field_price),
  field_services: singular_optional_text_long_parser(t.field_services),
  field_sticker: singular_optional_string_parser(t.field_sticker),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_subscriptions_guard = (t: Paragraph): t is ParagraphSubscriptions => paragraph_bundle_parser(t.type) == "subscriptions"

export const entity_reference_revisions_paragraph_with_target_paragraph_text_field_inline_media_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphTextFieldInlineMediaItem): ParsedParagraphInlineMedia | undefined | undefined => (t.target !== undefined ? ((t: ParagraphInlineMedia): ParsedParagraphInlineMedia =>
    paragraph_inline_media_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_text_field_inline_media_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphTextFieldInlineMediaItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const singular_optional_entity_reference_revisions_paragraph_with_target_paragraph_text_field_inline_media_parser = (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphTextFieldInlineMediaItem>): ParsedParagraphInlineMedia | undefined | null => f && f.length > 0 && entity_reference_revisions_paragraph_with_target_paragraph_text_field_inline_media_item_guard(f[0]) ? entity_reference_revisions_paragraph_with_target_paragraph_text_field_inline_media_item_parser(f[0]) : null

export const paragraph_text_parser = (t: ParagraphText): ParsedParagraphText => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text" => "text")(t.type),
  field_inline_media: singular_optional_entity_reference_revisions_paragraph_with_target_paragraph_text_field_inline_media_parser(t.field_inline_media),
  field_primary_action: singular_optional_link_parser(t.field_primary_action),
  field_rich_text: singular_required_text_long_parser(t.field_rich_text),
  field_secondary_action: singular_optional_link_parser(t.field_secondary_action),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_text_guard = (t: Paragraph): t is ParagraphText => paragraph_bundle_parser(t.type) == "text"

export const paragraph_themakiezer_embed_parser = (t: ParagraphThemakiezerEmbed): ParsedParagraphThemakiezerEmbed => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "themakiezer_embed" => "themakiezer_embed")(t.type),
  field_text: singular_optional_string_long_parser(t.field_text),
  field_themakiezer_embed_id: singular_required_string_parser(t.field_themakiezer_embed_id),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_themakiezer_embed_guard = (t: Paragraph): t is ParagraphThemakiezerEmbed => paragraph_bundle_parser(t.type) == "themakiezer_embed"

export const paragraph_tipped_activities_block_parser = (t: ParagraphTippedActivitiesBlock): ParsedParagraphTippedActivitiesBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "tipped_activities_block" => "tipped_activities_block")(t.type),
  field_link: singular_required_link_parser(t.field_link),
  field_rich_text: singular_required_text_long_parser(t.field_rich_text),
  field_row_count: singular_optional_list_integer_parser(t.field_row_count),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_tipped_activities_block_guard = (t: Paragraph): t is ParagraphTippedActivitiesBlock => paragraph_bundle_parser(t.type) == "tipped_activities_block"

export const entity_reference_taxonomy_term_item_parser = (t: EntityReferenceTaxonomyTermItem): ParsedEntityReferenceTaxonomyTermItem => ({
  id: noop_parser<number>(t.target_id),
  url: t.url,
  label: t.target_label
})

export const singular_required_entity_reference_taxonomy_term_parser = (f: FieldItemList<EntityReferenceTaxonomyTermItem>): ParsedEntityReferenceTaxonomyTermItem => entity_reference_taxonomy_term_item_parser(f[0])

export const paragraph_vacancy_overview_parser = (t: ParagraphVacancyOverview): ParsedParagraphVacancyOverview => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "vacancy_overview" => "vacancy_overview")(t.type),
  field_category: singular_required_entity_reference_taxonomy_term_parser(t.field_category),
  field_placeholder_text: singular_optional_string_long_parser(t.field_placeholder_text),
  field_rich_text: singular_required_text_long_parser(t.field_rich_text),
  field_row_count: singular_optional_list_integer_parser(t.field_row_count),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_vacancy_overview_guard = (t: Paragraph): t is ParagraphVacancyOverview => paragraph_bundle_parser(t.type) == "vacancy_overview"

export const paragraph_wordcloud_block_parser = (t: ParagraphWordcloudBlock): ParsedParagraphWordcloudBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "wordcloud_block" => "wordcloud_block")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_formstack_field_id: singular_required_string_parser(t.field_formstack_field_id),
  field_formstack_form_id: singular_required_string_parser(t.field_formstack_form_id),
  field_label: singular_optional_string_parser(t.field_label),
  field_number_of_options: singular_required_integer_parser(t.field_number_of_options),
  field_primary_action: singular_optional_link_parser(t.field_primary_action),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_wordcloud_block_guard = (t: Paragraph): t is ParagraphWordcloudBlock => paragraph_bundle_parser(t.type) == "wordcloud_block"

export const paragraph_parser = (t: Paragraph): ParsedParagraph =>
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_book_guard(t) ?
    paragraph_book_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_collection_guard(t) ?
    paragraph_collection_parser(t) :
  paragraph_collection_group_guard(t) ?
    paragraph_collection_group_parser(t) :
  paragraph_collection_item_guard(t) ?
    paragraph_collection_item_parser(t) :
  paragraph_collection_search_bar_guard(t) ?
    paragraph_collection_search_bar_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_content_grid_item_guard(t) ?
    paragraph_content_grid_item_parser(t) :
  paragraph_content_grid_video_guard(t) ?
    paragraph_content_grid_video_parser(t) :
  paragraph_core_activity_cluster_guard(t) ?
    paragraph_core_activity_cluster_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_datetime_guard(t) ?
    paragraph_datetime_parser(t) :
  paragraph_expander_item_guard(t) ?
    paragraph_expander_item_parser(t) :
  paragraph_expanders_guard(t) ?
    paragraph_expanders_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
  paragraph_featured_content_guard(t) ?
    paragraph_featured_content_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_grid_block_guard(t) ?
    paragraph_grid_block_parser(t) :
  paragraph_grid_items_guard(t) ?
    paragraph_grid_items_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_inline_media_guard(t) ?
    paragraph_inline_media_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_location_guard(t) ?
    paragraph_location_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_opening_hours_guard(t) ?
    paragraph_opening_hours_parser(t) :
  paragraph_page_grid_guard(t) ?
    paragraph_page_grid_parser(t) :
  paragraph_panorama_guard(t) ?
    paragraph_panorama_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_recent_news_guard(t) ?
    paragraph_recent_news_parser(t) :
  paragraph_submenu_guard(t) ?
    paragraph_submenu_parser(t) :
  paragraph_submenu_item_guard(t) ?
    paragraph_submenu_item_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
  paragraph_subscriptions_guard(t) ?
    paragraph_subscriptions_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_themakiezer_embed_guard(t) ?
    paragraph_themakiezer_embed_parser(t) :
  paragraph_tipped_activities_block_guard(t) ?
    paragraph_tipped_activities_block_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
    paragraph_wordcloud_block_parser(t)

export const paragraph_guard = (t: Entity): t is Paragraph => (
  (t as any).id !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).revision_id !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).type !== undefined &&
  (t as any).type[0].target_type == "paragraphs_type" &&
  (t as any).status !== undefined &&
  (t as any).created !== undefined &&
  (t as any).parent_id !== undefined &&
  (t as any).parent_type !== undefined &&
  (t as any).parent_field_name !== undefined &&
  (t as any).behavior_settings !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined
)

export const entity_reference_revisions_paragraph_with_target_node_activity_clusters_field_core_activity_clusters_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeActivityClustersFieldCoreActivityClustersItem): ParsedParagraphCoreActivityCluster | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCoreActivityCluster): ParsedParagraphCoreActivityCluster =>
    paragraph_core_activity_cluster_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_activity_clusters_field_core_activity_clusters_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeActivityClustersFieldCoreActivityClustersItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_activity_clusters_field_core_activity_clusters_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeActivityClustersFieldCoreActivityClustersItem>): List<ParsedParagraphCoreActivityCluster> =>
    List<ParsedParagraphCoreActivityCluster>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_activity_clusters_field_core_activity_clusters_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_activity_clusters_field_core_activity_clusters_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_with_target_node_activity_clusters_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeActivityClustersFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_activity_clusters_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeActivityClustersFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_activity_clusters_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeActivityClustersFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_activity_clusters_field_media_item_parser(f[0])

export const metatag_item_parser = (t: MetatagItem): any => noop_parser<any>(t.value)

export const singular_optional_metatag_parser = (f: FieldItemList<MetatagItem>): any | null => f && f.length > 0 ? metatag_item_parser(f[0]) : null

export const node_activity_clusters_parser = (t: NodeActivityClusters): ParsedNodeActivityClusters => ({
  ...node_base_parser(t),
  bundle: ((_: any): "activity_clusters" => "activity_clusters")(t.type),
  field_core_activity_clusters: plural_entity_reference_revisions_paragraph_with_target_node_activity_clusters_field_core_activity_clusters_parser(t.field_core_activity_clusters),
  field_cta_description: singular_optional_text_long_parser(t.field_cta_description),
  field_cta_primary_action: singular_optional_link_parser(t.field_cta_primary_action),
  field_cta_secondary_action: singular_optional_link_parser(t.field_cta_secondary_action),
  field_cta_title: singular_optional_string_parser(t.field_cta_title),
  field_description: singular_required_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_kern_activiteiten_aantal: singular_optional_list_string_parser(t.field_kern_activiteiten_aantal),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_media: singular_required_entity_reference_media_with_target_node_activity_clusters_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_short_description: singular_optional_string_parser(t.field_short_description),
  field_toggle_cta: singular_optional_boolean_parser(t.field_toggle_cta)
})

export const node_activity_clusters_guard = (t: Node): t is NodeActivityClusters => node_bundle_parser(t.type) == "activity_clusters"

export const entity_reference_media_with_target_node_activity_detail_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeActivityDetailFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_activity_detail_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeActivityDetailFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_activity_detail_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeActivityDetailFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_activity_detail_field_media_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_activity_detail_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeActivityDetailFieldParagraphsItem): ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphThemakiezerEmbed | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphImages | ParagraphBooks | ParagraphCtaBlock | ParagraphCaroussel | ParagraphCollection | ParagraphContentGrid | ParagraphFormstackBlock | ParagraphHighlight | ParagraphKnop | ParagraphMedia | ParagraphNewsletterSignupForm | ParagraphQuote | ParagraphThemakiezerEmbed | ParagraphFaqCollection | ParagraphWordcloudBlock): ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphThemakiezerEmbed | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_collection_guard(t) ?
    paragraph_collection_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_themakiezer_embed_guard(t) ?
    paragraph_themakiezer_embed_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_activity_detail_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeActivityDetailFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_activity_detail_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeActivityDetailFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphThemakiezerEmbed | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphThemakiezerEmbed | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_activity_detail_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_activity_detail_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const singular_optional_product_db_entity_parser = (f: FieldItemList<ProductDbEntityItem>): number | null => f && f.length > 0 ? product_db_entity_item_parser(f[0]) : null

export const node_activity_detail_parser = (t: NodeActivityDetail): ParsedNodeActivityDetail => ({
  ...node_base_parser(t),
  bundle: ((_: any): "activity_detail" => "activity_detail")(t.type),
  field_description: singular_required_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_media: singular_required_entity_reference_media_with_target_node_activity_detail_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_notice_contents: singular_optional_text_long_parser(t.field_notice_contents),
  field_notice_title: singular_optional_string_parser(t.field_notice_title),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_activity_detail_field_paragraphs_parser(t.field_paragraphs),
  field_product_db_id: singular_optional_product_db_entity_parser(t.field_product_db_id),
  field_short_description: singular_required_string_parser(t.field_short_description)
})

export const node_activity_detail_guard = (t: Node): t is NodeActivityDetail => node_bundle_parser(t.type) == "activity_detail"

export const entity_reference_media_with_target_node_blog_overview_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeBlogOverviewFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_blog_overview_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeBlogOverviewFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_blog_overview_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeBlogOverviewFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_blog_overview_field_media_item_parser(f[0])

export const node_blog_overview_parser = (t: NodeBlogOverview): ParsedNodeBlogOverview => ({
  ...node_base_parser(t),
  bundle: ((_: any): "blog_overview" => "blog_overview")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_media: singular_required_entity_reference_media_with_target_node_blog_overview_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_blog_overview_guard = (t: Node): t is NodeBlogOverview => node_bundle_parser(t.type) == "blog_overview"

export const plural_entity_reference_taxonomy_term_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermItem>): List<ParsedEntityReferenceTaxonomyTermItem> =>
    List<ParsedEntityReferenceTaxonomyTermItem>(f.map(i => entity_reference_taxonomy_term_item_parser(i)))

export const entity_reference_media_with_target_node_blog_post_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeBlogPostFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_blog_post_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeBlogPostFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_blog_post_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeBlogPostFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_blog_post_field_media_item_guard(f[0]) ? entity_reference_media_with_target_node_blog_post_field_media_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_blog_post_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeBlogPostFieldParagraphsItem): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBook | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphActivityCluster | ParagraphImages | ParagraphBook | ParagraphBooks | ParagraphCtaBlock | ParagraphCaroussel | ParagraphContentGrid | ParagraphHighlight | ParagraphKnop | ParagraphMedia | ParagraphQuote | ParagraphSubscriptionBlock | ParagraphVacancyOverview | ParagraphFaqCollection): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBook | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_book_guard(t) ?
    paragraph_book_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
    paragraph_faq_collection_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_blog_post_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeBlogPostFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_blog_post_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeBlogPostFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBook | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection> =>
    List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBook | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_blog_post_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_blog_post_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const node_blog_post_parser = (t: NodeBlogPost): ParsedNodeBlogPost => ({
  ...node_base_parser(t),
  bundle: ((_: any): "blog_post" => "blog_post")(t.type),
  field_blog_category: plural_entity_reference_taxonomy_term_parser(t.field_blog_category),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_media: singular_optional_entity_reference_media_with_target_node_blog_post_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_blog_post_field_paragraphs_parser(t.field_paragraphs),
  field_short_description: singular_optional_string_parser(t.field_short_description),
  field_tags: plural_entity_reference_taxonomy_term_parser(t.field_tags)
})

export const node_blog_post_guard = (t: Node): t is NodeBlogPost => node_bundle_parser(t.type) == "blog_post"

export const entity_reference_media_with_target_node_collection_overview_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeCollectionOverviewFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_collection_overview_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeCollectionOverviewFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_collection_overview_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeCollectionOverviewFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_collection_overview_field_media_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeCollectionOverviewFieldParagraphsItem): ParsedParagraphCollection | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphBook | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphThemakiezerEmbed | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCollection | ParagraphActivityCluster | ParagraphImages | ParagraphBooks | ParagraphBook | ParagraphCtaBlock | ParagraphCaroussel | ParagraphContentGrid | ParagraphFormstackBlock | ParagraphGridBlock | ParagraphHighlight | ParagraphKnop | ParagraphMedia | ParagraphNewsletterSignupForm | ParagraphQuote | ParagraphText | ParagraphThemakiezerEmbed | ParagraphVacancyOverview | ParagraphFaqCollection | ParagraphWordcloudBlock): ParsedParagraphCollection | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphBook | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphThemakiezerEmbed | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock =>
  paragraph_collection_guard(t) ?
    paragraph_collection_parser(t) :
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_book_guard(t) ?
    paragraph_book_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_grid_block_guard(t) ?
    paragraph_grid_block_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_themakiezer_embed_guard(t) ?
    paragraph_themakiezer_embed_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeCollectionOverviewFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeCollectionOverviewFieldParagraphsItem>): List<ParsedParagraphCollection | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphBook | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphThemakiezerEmbed | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphCollection | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphBook | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphThemakiezerEmbed | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_header_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeCollectionOverviewFieldParagraphsHeaderItem): ParsedParagraphSubmenu | undefined | undefined => (t.target !== undefined ? ((t: ParagraphSubmenu): ParsedParagraphSubmenu =>
    paragraph_submenu_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_header_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeCollectionOverviewFieldParagraphsHeaderItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_header_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeCollectionOverviewFieldParagraphsHeaderItem>): List<ParsedParagraphSubmenu> =>
    List<ParsedParagraphSubmenu>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_header_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_header_item_parser(i)).filter(i => i !== undefined))

export const node_collection_overview_parser = (t: NodeCollectionOverview): ParsedNodeCollectionOverview => ({
  ...node_base_parser(t),
  bundle: ((_: any): "collection_overview" => "collection_overview")(t.type),
  field_description: singular_required_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_media: singular_required_entity_reference_media_with_target_node_collection_overview_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_parser(t.field_paragraphs),
  field_paragraphs_header: plural_entity_reference_revisions_paragraph_with_target_node_collection_overview_field_paragraphs_header_parser(t.field_paragraphs_header),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_collection_overview_guard = (t: Node): t is NodeCollectionOverview => node_bundle_parser(t.type) == "collection_overview"

export const entity_reference_media_with_target_node_event_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeEventFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_event_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeEventFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_event_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeEventFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_event_field_media_item_guard(f[0]) ? entity_reference_media_with_target_node_event_field_media_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeEventFieldParagraphsItem): ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphPanorama | ParsedParagraphQuote | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphImages | ParagraphBooks | ParagraphCtaBlock | ParagraphCaroussel | ParagraphCollection | ParagraphContentGrid | ParagraphFormstackBlock | ParagraphHighlight | ParagraphKnop | ParagraphMedia | ParagraphNewsletterSignupForm | ParagraphPanorama | ParagraphQuote | ParagraphThemakiezerEmbed | ParagraphExpanders | ParagraphFaqCollection | ParagraphWordcloudBlock): ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphPanorama | ParsedParagraphQuote | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_collection_guard(t) ?
    paragraph_collection_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_panorama_guard(t) ?
    paragraph_panorama_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_themakiezer_embed_guard(t) ?
    paragraph_themakiezer_embed_parser(t) :
  paragraph_expanders_guard(t) ?
    paragraph_expanders_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeEventFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeEventFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphPanorama | ParsedParagraphQuote | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphPanorama | ParsedParagraphQuote | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const node_event_parser = (t: NodeEvent): ParsedNodeEvent => ({
  ...node_base_parser(t),
  bundle: ((_: any): "event" => "event")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_title: singular_optional_string_parser(t.field_header_title),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_media: singular_optional_entity_reference_media_with_target_node_event_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_notice_contents: singular_optional_text_long_parser(t.field_notice_contents),
  field_notice_title: singular_optional_string_parser(t.field_notice_title),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_parser(t.field_paragraphs),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_event_guard = (t: Node): t is NodeEvent => node_bundle_parser(t.type) == "event"

export const node_faq_parser = (t: NodeFaq): ParsedNodeFaq => ({
  ...node_base_parser(t),
  bundle: ((_: any): "faq" => "faq")(t.type),
  field_answer: singular_required_text_long_parser(t.field_answer)
})

export const node_faq_guard = (t: Node): t is NodeFaq => node_bundle_parser(t.type) == "faq"

export const entity_reference_media_with_target_node_home_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeHomeFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_home_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeHomeFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_home_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeHomeFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_home_field_media_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_home_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeHomeFieldParagraphsItem): ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFeaturedContent | ParsedParagraphFormstackBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphGridBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphPageGrid | ParsedParagraphRecentNews | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCtaBlock | ParagraphCaroussel | ParagraphCollectionSearchBar | ParagraphContentGrid | ParagraphFeaturedContent | ParagraphFormstackBlock | ParagraphTippedActivitiesBlock | ParagraphGridBlock | ParagraphNewsletterSignupForm | ParagraphPageGrid | ParagraphRecentNews | ParagraphThemakiezerEmbed | ParagraphExpanders | ParagraphWordcloudBlock): ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFeaturedContent | ParsedParagraphFormstackBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphGridBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphPageGrid | ParsedParagraphRecentNews | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphWordcloudBlock =>
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_collection_search_bar_guard(t) ?
    paragraph_collection_search_bar_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_featured_content_guard(t) ?
    paragraph_featured_content_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_tipped_activities_block_guard(t) ?
    paragraph_tipped_activities_block_parser(t) :
  paragraph_grid_block_guard(t) ?
    paragraph_grid_block_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_page_grid_guard(t) ?
    paragraph_page_grid_parser(t) :
  paragraph_recent_news_guard(t) ?
    paragraph_recent_news_parser(t) :
  paragraph_themakiezer_embed_guard(t) ?
    paragraph_themakiezer_embed_parser(t) :
  paragraph_expanders_guard(t) ?
    paragraph_expanders_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_home_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeHomeFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_home_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeHomeFieldParagraphsItem>): List<ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFeaturedContent | ParsedParagraphFormstackBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphGridBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphPageGrid | ParsedParagraphRecentNews | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFeaturedContent | ParsedParagraphFormstackBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphGridBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphPageGrid | ParsedParagraphRecentNews | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_home_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_home_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_revisions_paragraph_with_target_node_home_field_universal_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeHomeFieldUniversalParagraphsItem): ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFeaturedContent | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphPageGrid | ParsedParagraphRecentNews | ParsedParagraphExpanders | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCtaBlock | ParagraphCaroussel | ParagraphCollectionSearchBar | ParagraphContentGrid | ParagraphFeaturedContent | ParagraphFormstackBlock | ParagraphGridBlock | ParagraphPageGrid | ParagraphRecentNews | ParagraphExpanders): ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFeaturedContent | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphPageGrid | ParsedParagraphRecentNews | ParsedParagraphExpanders =>
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_collection_search_bar_guard(t) ?
    paragraph_collection_search_bar_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_featured_content_guard(t) ?
    paragraph_featured_content_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_grid_block_guard(t) ?
    paragraph_grid_block_parser(t) :
  paragraph_page_grid_guard(t) ?
    paragraph_page_grid_parser(t) :
  paragraph_recent_news_guard(t) ?
    paragraph_recent_news_parser(t) :
    paragraph_expanders_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_home_field_universal_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeHomeFieldUniversalParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_home_field_universal_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeHomeFieldUniversalParagraphsItem>): List<ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFeaturedContent | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphPageGrid | ParsedParagraphRecentNews | ParsedParagraphExpanders> =>
    List<ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFeaturedContent | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphPageGrid | ParsedParagraphRecentNews | ParsedParagraphExpanders>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_home_field_universal_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_home_field_universal_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const node_home_parser = (t: NodeHome): ParsedNodeHome => ({
  ...node_base_parser(t),
  bundle: ((_: any): "home" => "home")(t.type),
  field_announcement: singular_optional_text_long_parser(t.field_announcement),
  field_description: singular_required_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_media: singular_required_entity_reference_media_with_target_node_home_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_notice_contents: singular_optional_text_long_parser(t.field_notice_contents),
  field_notice_title: singular_optional_string_parser(t.field_notice_title),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_home_field_paragraphs_parser(t.field_paragraphs),
  field_short_description: singular_optional_string_parser(t.field_short_description),
  field_show_announcement: singular_optional_boolean_parser(t.field_show_announcement),
  field_universal_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_home_field_universal_paragraphs_parser(t.field_universal_paragraphs)
})

export const node_home_guard = (t: Node): t is NodeHome => node_bundle_parser(t.type) == "home"

export const entity_reference_media_with_target_node_location_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeLocationFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_location_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeLocationFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_location_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeLocationFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_location_field_media_item_guard(f[0]) ? entity_reference_media_with_target_node_location_field_media_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeLocationFieldParagraphsItem): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphActivityCluster | ParagraphImages | ParagraphBooks | ParagraphCtaBlock | ParagraphCaroussel | ParagraphContentGrid | ParagraphHighlight | ParagraphKnop | ParagraphMedia | ParagraphQuote | ParagraphSubscriptionBlock | ParagraphVacancyOverview | ParagraphFaqCollection): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
    paragraph_faq_collection_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeLocationFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeLocationFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection> =>
    List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_upper_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeLocationFieldParagraphsUpperItem): ParsedParagraphActivityCluster | ParsedParagraphBooks | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFaqCollection | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphHighlight | ParsedParagraphImages | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphPanorama | ParsedParagraphRecentNews | ParsedParagraphSubscriptionBlock | ParsedParagraphText | ParsedParagraphVacancyOverview | undefined | undefined => (t.target !== undefined ? ((t: ParagraphActivityCluster | ParagraphBooks | ParagraphCaroussel | ParagraphContentGrid | ParagraphFaqCollection | ParagraphFormstackBlock | ParagraphGridBlock | ParagraphHighlight | ParagraphImages | ParagraphKnop | ParagraphMedia | ParagraphQuote | ParagraphPanorama | ParagraphRecentNews | ParagraphSubscriptionBlock | ParagraphText | ParagraphVacancyOverview): ParsedParagraphActivityCluster | ParsedParagraphBooks | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFaqCollection | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphHighlight | ParsedParagraphImages | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphPanorama | ParsedParagraphRecentNews | ParsedParagraphSubscriptionBlock | ParsedParagraphText | ParsedParagraphVacancyOverview =>
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_grid_block_guard(t) ?
    paragraph_grid_block_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_panorama_guard(t) ?
    paragraph_panorama_parser(t) :
  paragraph_recent_news_guard(t) ?
    paragraph_recent_news_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
    paragraph_vacancy_overview_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_upper_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeLocationFieldParagraphsUpperItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_upper_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeLocationFieldParagraphsUpperItem>): List<ParsedParagraphActivityCluster | ParsedParagraphBooks | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFaqCollection | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphHighlight | ParsedParagraphImages | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphPanorama | ParsedParagraphRecentNews | ParsedParagraphSubscriptionBlock | ParsedParagraphText | ParsedParagraphVacancyOverview> =>
    List<ParsedParagraphActivityCluster | ParsedParagraphBooks | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFaqCollection | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphHighlight | ParsedParagraphImages | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphPanorama | ParsedParagraphRecentNews | ParsedParagraphSubscriptionBlock | ParsedParagraphText | ParsedParagraphVacancyOverview>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_upper_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_upper_item_parser(i)).filter(i => i !== undefined))

export const node_location_parser = (t: NodeLocation): ParsedNodeLocation => ({
  ...node_base_parser(t),
  bundle: ((_: any): "location" => "location")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_hide_form: singular_optional_boolean_parser(t.field_hide_form),
  field_jumbo_small: singular_optional_boolean_parser(t.field_jumbo_small),
  field_location_id: singular_required_string_parser(t.field_location_id),
  field_media: singular_optional_entity_reference_media_with_target_node_location_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_parser(t.field_paragraphs),
  field_paragraphs_upper: plural_entity_reference_revisions_paragraph_with_target_node_location_field_paragraphs_upper_parser(t.field_paragraphs_upper),
  field_price: singular_optional_string_parser(t.field_price),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_location_guard = (t: Node): t is NodeLocation => node_bundle_parser(t.type) == "location"

export const address_item_parser = (t: AddressItem): ParsedAddressItem => ({
  langcode: noop_parser<string | null>(t.langcode),
  country_code: noop_parser<string | null>(t.country_code),
  administrative_area: noop_parser<string | null>(t.administrative_area),
  locality: noop_parser<string | null>(t.locality),
  dependent_locality: noop_parser<string | null>(t.dependent_locality),
  postal_code: noop_parser<string | null>(t.postal_code),
  sorting_code: noop_parser<string | null>(t.sorting_code),
  address_line1: noop_parser<string | null>(t.address_line1),
  address_line2: noop_parser<string | null>(t.address_line2),
  address_line3: noop_parser<string | null>(t.address_line3),
  organization: noop_parser<string | null>(t.organization),
  given_name: noop_parser<string | null>(t.given_name),
  additional_name: noop_parser<string | null>(t.additional_name),
  family_name: noop_parser<string | null>(t.family_name)
})

export const singular_optional_address_parser = (f: FieldItemList<AddressItem>): ParsedAddressItem | null => f && f.length > 0 ? address_item_parser(f[0]) : null

export const email_item_parser = (t: EmailItem): string => noop_parser<string>(t.value)

export const singular_optional_email_parser = (f: FieldItemList<EmailItem>): string | null => f && f.length > 0 ? email_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_location_detail_field_location_opening_hours_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeLocationDetailFieldLocationOpeningHoursItem): ParsedParagraphOpeningHours | undefined | undefined => (t.target !== undefined ? ((t: ParagraphOpeningHours): ParsedParagraphOpeningHours =>
    paragraph_opening_hours_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_location_detail_field_location_opening_hours_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeLocationDetailFieldLocationOpeningHoursItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_location_detail_field_location_opening_hours_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeLocationDetailFieldLocationOpeningHoursItem>): List<ParsedParagraphOpeningHours> =>
    List<ParsedParagraphOpeningHours>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_location_detail_field_location_opening_hours_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_location_detail_field_location_opening_hours_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_with_target_node_location_detail_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeLocationDetailFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_location_detail_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeLocationDetailFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_location_detail_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeLocationDetailFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_location_detail_field_media_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_location_detail_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeLocationDetailFieldParagraphsItem): ParsedParagraphText | ParsedParagraphSubscriptions | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphThemakiezerEmbed | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphExpanders | ParsedParagraphFeaturedContent | ParsedParagraphPageGrid | ParsedParagraphCollectionSearchBar | ParsedParagraphRecentNews | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphSubscriptions | ParagraphActivityCluster | ParagraphImages | ParagraphBooks | ParagraphCtaBlock | ParagraphCaroussel | ParagraphCollection | ParagraphContentGrid | ParagraphFormstackBlock | ParagraphTippedActivitiesBlock | ParagraphHighlight | ParagraphKnop | ParagraphMedia | ParagraphNewsletterSignupForm | ParagraphQuote | ParagraphSubscriptionBlock | ParagraphThemakiezerEmbed | ParagraphVacancyOverview | ParagraphFaqCollection | ParagraphExpanders | ParagraphFeaturedContent | ParagraphPageGrid | ParagraphCollectionSearchBar | ParagraphRecentNews | ParagraphWordcloudBlock): ParsedParagraphText | ParsedParagraphSubscriptions | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphThemakiezerEmbed | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphExpanders | ParsedParagraphFeaturedContent | ParsedParagraphPageGrid | ParsedParagraphCollectionSearchBar | ParsedParagraphRecentNews | ParsedParagraphWordcloudBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_subscriptions_guard(t) ?
    paragraph_subscriptions_parser(t) :
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_collection_guard(t) ?
    paragraph_collection_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_tipped_activities_block_guard(t) ?
    paragraph_tipped_activities_block_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
  paragraph_themakiezer_embed_guard(t) ?
    paragraph_themakiezer_embed_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
  paragraph_expanders_guard(t) ?
    paragraph_expanders_parser(t) :
  paragraph_featured_content_guard(t) ?
    paragraph_featured_content_parser(t) :
  paragraph_page_grid_guard(t) ?
    paragraph_page_grid_parser(t) :
  paragraph_collection_search_bar_guard(t) ?
    paragraph_collection_search_bar_parser(t) :
  paragraph_recent_news_guard(t) ?
    paragraph_recent_news_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_location_detail_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeLocationDetailFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_location_detail_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeLocationDetailFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphSubscriptions | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphThemakiezerEmbed | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphExpanders | ParsedParagraphFeaturedContent | ParsedParagraphPageGrid | ParsedParagraphCollectionSearchBar | ParsedParagraphRecentNews | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphText | ParsedParagraphSubscriptions | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphThemakiezerEmbed | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphExpanders | ParsedParagraphFeaturedContent | ParsedParagraphPageGrid | ParsedParagraphCollectionSearchBar | ParsedParagraphRecentNews | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_location_detail_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_location_detail_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const product_db_item_item_parser = (t: ProductDbItemItem): number => noop_parser<number>(t.target_id)

export const singular_optional_product_db_item_parser = (f: FieldItemList<ProductDbItemItem>): number | null => f && f.length > 0 ? product_db_item_item_parser(f[0]) : null

export const node_location_detail_parser = (t: NodeLocationDetail): ParsedNodeLocationDetail => ({
  ...node_base_parser(t),
  bundle: ((_: any): "location_detail" => "location_detail")(t.type),
  field_about_contents: singular_optional_text_long_parser(t.field_about_contents),
  field_about_title: singular_optional_string_parser(t.field_about_title),
  field_address: singular_optional_address_parser(t.field_address),
  field_contact_customer_service: singular_optional_text_long_parser(t.field_contact_customer_service),
  field_current_contents: singular_optional_text_long_parser(t.field_current_contents),
  field_current_title: singular_optional_string_parser(t.field_current_title),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_email: singular_optional_email_parser(t.field_email),
  field_google_placeid: singular_optional_string_parser(t.field_google_placeid),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_location_opening_hours: plural_entity_reference_revisions_paragraph_with_target_node_location_detail_field_location_opening_hours_parser(t.field_location_opening_hours),
  field_media: singular_required_entity_reference_media_with_target_node_location_detail_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_location_detail_field_paragraphs_parser(t.field_paragraphs),
  field_product_db_id: singular_optional_product_db_item_parser(t.field_product_db_id),
  field_sharepoint_locatie: singular_optional_product_db_entity_parser(t.field_sharepoint_locatie),
  field_short_description: singular_optional_string_parser(t.field_short_description),
  field_telefoonnummer: singular_optional_string_parser(t.field_telefoonnummer)
})

export const node_location_detail_guard = (t: Node): t is NodeLocationDetail => node_bundle_parser(t.type) == "location_detail"

export const entity_reference_media_with_target_node_location_overview_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeLocationOverviewFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_location_overview_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeLocationOverviewFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_location_overview_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeLocationOverviewFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_location_overview_field_media_item_guard(f[0]) ? entity_reference_media_with_target_node_location_overview_field_media_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeLocationOverviewFieldParagraphsItem): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphActivityCluster | ParagraphImages | ParagraphBooks | ParagraphCtaBlock | ParagraphCaroussel | ParagraphContentGrid | ParagraphHighlight | ParagraphKnop | ParagraphMedia | ParagraphQuote | ParagraphSubscriptionBlock | ParagraphVacancyOverview | ParagraphFaqCollection): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
    paragraph_faq_collection_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeLocationOverviewFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeLocationOverviewFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection> =>
    List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_upper_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeLocationOverviewFieldParagraphsUpperItem): ParsedParagraphMedia | ParsedParagraphText | ParsedParagraphFaqCollection | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphImages | ParsedParagraphContentGrid | ParsedParagraphActivityCluster | ParsedParagraphVacancyOverview | ParsedParagraphBooks | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphCaroussel | undefined | undefined => (t.target !== undefined ? ((t: ParagraphMedia | ParagraphText | ParagraphFaqCollection | ParagraphHighlight | ParagraphKnop | ParagraphImages | ParagraphContentGrid | ParagraphActivityCluster | ParagraphVacancyOverview | ParagraphBooks | ParagraphQuote | ParagraphSubscriptionBlock | ParagraphCaroussel): ParsedParagraphMedia | ParsedParagraphText | ParsedParagraphFaqCollection | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphImages | ParsedParagraphContentGrid | ParsedParagraphActivityCluster | ParsedParagraphVacancyOverview | ParsedParagraphBooks | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphCaroussel =>
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
    paragraph_caroussel_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_upper_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeLocationOverviewFieldParagraphsUpperItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_upper_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeLocationOverviewFieldParagraphsUpperItem>): List<ParsedParagraphMedia | ParsedParagraphText | ParsedParagraphFaqCollection | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphImages | ParsedParagraphContentGrid | ParsedParagraphActivityCluster | ParsedParagraphVacancyOverview | ParsedParagraphBooks | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphCaroussel> =>
    List<ParsedParagraphMedia | ParsedParagraphText | ParsedParagraphFaqCollection | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphImages | ParsedParagraphContentGrid | ParsedParagraphActivityCluster | ParsedParagraphVacancyOverview | ParsedParagraphBooks | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphCaroussel>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_upper_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_upper_item_parser(i)).filter(i => i !== undefined))

export const node_location_overview_parser = (t: NodeLocationOverview): ParsedNodeLocationOverview => ({
  ...node_base_parser(t),
  bundle: ((_: any): "location_overview" => "location_overview")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_jumbo_small: singular_optional_boolean_parser(t.field_jumbo_small),
  field_media: singular_optional_entity_reference_media_with_target_node_location_overview_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_parser(t.field_paragraphs),
  field_paragraphs_upper: plural_entity_reference_revisions_paragraph_with_target_node_location_overview_field_paragraphs_upper_parser(t.field_paragraphs_upper),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_location_overview_guard = (t: Node): t is NodeLocationOverview => node_bundle_parser(t.type) == "location_overview"

export const entity_reference_media_with_target_node_news_item_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeNewsItemFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_news_item_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeNewsItemFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_news_item_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeNewsItemFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_news_item_field_media_item_guard(f[0]) ? entity_reference_media_with_target_node_news_item_field_media_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_news_item_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeNewsItemFieldParagraphsItem): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBook | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphIframe | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphActivityCluster | ParagraphImages | ParagraphBook | ParagraphBooks | ParagraphCtaBlock | ParagraphCaroussel | ParagraphContentGrid | ParagraphHighlight | ParagraphIframe | ParagraphKnop | ParagraphMedia | ParagraphQuote | ParagraphSubscriptionBlock | ParagraphVacancyOverview | ParagraphFaqCollection): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBook | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphIframe | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_book_guard(t) ?
    paragraph_book_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
    paragraph_faq_collection_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_news_item_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeNewsItemFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_news_item_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeNewsItemFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBook | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphIframe | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection> =>
    List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBook | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphHighlight | ParsedParagraphIframe | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphSubscriptionBlock | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_news_item_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_news_item_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const node_news_item_parser = (t: NodeNewsItem): ParsedNodeNewsItem => ({
  ...node_base_parser(t),
  bundle: ((_: any): "news_item" => "news_item")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_media: singular_optional_entity_reference_media_with_target_node_news_item_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_news_item_field_paragraphs_parser(t.field_paragraphs),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_news_item_guard = (t: Node): t is NodeNewsItem => node_bundle_parser(t.type) == "news_item"

export const entity_reference_media_with_target_node_news_overview_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeNewsOverviewFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_news_overview_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeNewsOverviewFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_news_overview_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeNewsOverviewFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_news_overview_field_media_item_parser(f[0])

export const node_news_overview_parser = (t: NodeNewsOverview): ParsedNodeNewsOverview => ({
  ...node_base_parser(t),
  bundle: ((_: any): "news_overview" => "news_overview")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_media: singular_required_entity_reference_media_with_target_node_news_overview_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_news_overview_guard = (t: Node): t is NodeNewsOverview => node_bundle_parser(t.type) == "news_overview"

export const entity_reference_media_with_target_node_newsletter_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeNewsletterFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_newsletter_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeNewsletterFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_newsletter_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeNewsletterFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_newsletter_field_media_item_parser(f[0])

export const node_newsletter_parser = (t: NodeNewsletter): ParsedNodeNewsletter => ({
  ...node_base_parser(t),
  bundle: ((_: any): "newsletter" => "newsletter")(t.type),
  field_description: singular_required_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_media: singular_required_entity_reference_media_with_target_node_newsletter_field_media_parser(t.field_media),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_newsletter_guard = (t: Node): t is NodeNewsletter => node_bundle_parser(t.type) == "newsletter"

export const entity_reference_media_with_target_node_page_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodePageFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_page_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodePageFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_page_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodePageFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_page_field_media_item_guard(f[0]) ? entity_reference_media_with_target_node_page_field_media_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_page_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodePageFieldParagraphsItem): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphHighlight | ParsedParagraphIframe | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphRecentNews | ParsedParagraphSubscriptionBlock | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphActivityCluster | ParagraphImages | ParagraphBooks | ParagraphCtaBlock | ParagraphCaroussel | ParagraphCollection | ParagraphCollectionSearchBar | ParagraphContentGrid | ParagraphFormstackBlock | ParagraphGridBlock | ParagraphTippedActivitiesBlock | ParagraphHighlight | ParagraphIframe | ParagraphKnop | ParagraphMedia | ParagraphNewsletterSignupForm | ParagraphQuote | ParagraphRecentNews | ParagraphSubscriptionBlock | ParagraphThemakiezerEmbed | ParagraphExpanders | ParagraphVacancyOverview | ParagraphFaqCollection | ParagraphWordcloudBlock): ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphHighlight | ParsedParagraphIframe | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphRecentNews | ParsedParagraphSubscriptionBlock | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_activity_cluster_guard(t) ?
    paragraph_activity_cluster_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_collection_guard(t) ?
    paragraph_collection_parser(t) :
  paragraph_collection_search_bar_guard(t) ?
    paragraph_collection_search_bar_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_grid_block_guard(t) ?
    paragraph_grid_block_parser(t) :
  paragraph_tipped_activities_block_guard(t) ?
    paragraph_tipped_activities_block_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_recent_news_guard(t) ?
    paragraph_recent_news_parser(t) :
  paragraph_subscription_block_guard(t) ?
    paragraph_subscription_block_parser(t) :
  paragraph_themakiezer_embed_guard(t) ?
    paragraph_themakiezer_embed_parser(t) :
  paragraph_expanders_guard(t) ?
    paragraph_expanders_parser(t) :
  paragraph_vacancy_overview_guard(t) ?
    paragraph_vacancy_overview_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_page_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodePageFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_page_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodePageFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphHighlight | ParsedParagraphIframe | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphRecentNews | ParsedParagraphSubscriptionBlock | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphText | ParsedParagraphActivityCluster | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphCollection | ParsedParagraphCollectionSearchBar | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphGridBlock | ParsedParagraphTippedActivitiesBlock | ParsedParagraphHighlight | ParsedParagraphIframe | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphRecentNews | ParsedParagraphSubscriptionBlock | ParsedParagraphThemakiezerEmbed | ParsedParagraphExpanders | ParsedParagraphVacancyOverview | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_page_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_page_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const node_page_parser = (t: NodePage): ParsedNodePage => ({
  ...node_base_parser(t),
  bundle: ((_: any): "page" => "page")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_jumbo_small: singular_optional_boolean_parser(t.field_jumbo_small),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_media: singular_optional_entity_reference_media_with_target_node_page_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_page_field_paragraphs_parser(t.field_paragraphs),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_page_guard = (t: Node): t is NodePage => node_bundle_parser(t.type) == "page"

export const entity_reference_revisions_paragraph_with_target_node_report_field_datetime_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeReportFieldDatetimeItemsItem): ParsedParagraphDatetime | undefined | undefined => (t.target !== undefined ? ((t: ParagraphDatetime): ParsedParagraphDatetime =>
    paragraph_datetime_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_report_field_datetime_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeReportFieldDatetimeItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_report_field_datetime_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeReportFieldDatetimeItemsItem>): List<ParsedParagraphDatetime> =>
    List<ParsedParagraphDatetime>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_report_field_datetime_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_report_field_datetime_items_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_revisions_paragraph_with_target_node_report_field_location_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeReportFieldLocationItemsItem): ParsedParagraphLocation | undefined | undefined => (t.target !== undefined ? ((t: ParagraphLocation): ParsedParagraphLocation =>
    paragraph_location_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_report_field_location_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeReportFieldLocationItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_report_field_location_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeReportFieldLocationItemsItem>): List<ParsedParagraphLocation> =>
    List<ParsedParagraphLocation>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_report_field_location_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_report_field_location_items_item_parser(i)).filter(i => i !== undefined))

export const entity_reference_media_with_target_node_report_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeReportFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_report_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeReportFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_report_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeReportFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_report_field_media_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_report_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeReportFieldParagraphsItem): ParsedParagraphMedia | ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphCaroussel | ParsedParagraphFormstackBlock | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphMedia | ParagraphText | ParagraphImages | ParagraphBooks | ParagraphCtaBlock | ParagraphNewsletterSignupForm | ParagraphQuote | ParagraphCaroussel | ParagraphFormstackBlock | ParagraphWordcloudBlock): ParsedParagraphMedia | ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphCaroussel | ParsedParagraphFormstackBlock | ParsedParagraphWordcloudBlock =>
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_books_guard(t) ?
    paragraph_books_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_report_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeReportFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_report_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeReportFieldParagraphsItem>): List<ParsedParagraphMedia | ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphCaroussel | ParsedParagraphFormstackBlock | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphMedia | ParsedParagraphText | ParsedParagraphImages | ParsedParagraphBooks | ParsedParagraphCtaBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphCaroussel | ParsedParagraphFormstackBlock | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_report_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_report_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const node_report_parser = (t: NodeReport): ParsedNodeReport => ({
  ...node_base_parser(t),
  bundle: ((_: any): "report" => "report")(t.type),
  field_datetime_items: plural_entity_reference_revisions_paragraph_with_target_node_report_field_datetime_items_parser(t.field_datetime_items),
  field_description: singular_required_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_jumbo_small: singular_optional_boolean_parser(t.field_jumbo_small),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_location_items: plural_entity_reference_revisions_paragraph_with_target_node_report_field_location_items_parser(t.field_location_items),
  field_media: singular_required_entity_reference_media_with_target_node_report_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_report_field_paragraphs_parser(t.field_paragraphs),
  field_short_description: singular_required_string_parser(t.field_short_description)
})

export const node_report_guard = (t: Node): t is NodeReport => node_bundle_parser(t.type) == "report"

export const entity_reference_media_with_target_node_report_overview_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeReportOverviewFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_report_overview_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeReportOverviewFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_report_overview_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeReportOverviewFieldMediaItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_report_overview_field_media_item_parser(f[0])

export const node_report_overview_parser = (t: NodeReportOverview): ParsedNodeReportOverview => ({
  ...node_base_parser(t),
  bundle: ((_: any): "report_overview" => "report_overview")(t.type),
  field_description: singular_required_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_jumbo_small: singular_optional_boolean_parser(t.field_jumbo_small),
  field_media: singular_required_entity_reference_media_with_target_node_report_overview_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_row_count: singular_optional_list_integer_parser(t.field_row_count),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_report_overview_guard = (t: Node): t is NodeReportOverview => node_bundle_parser(t.type) == "report_overview"

export const entity_reference_media_with_target_node_sections_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeSectionsFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_sections_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeSectionsFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_sections_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeSectionsFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_sections_field_media_item_guard(f[0]) ? entity_reference_media_with_target_node_sections_field_media_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_sections_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeSectionsFieldParagraphsItem): ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphFormstackBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphPageGrid | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCtaBlock | ParagraphCaroussel | ParagraphFormstackBlock | ParagraphNewsletterSignupForm | ParagraphPageGrid | ParagraphWordcloudBlock): ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphFormstackBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphPageGrid | ParsedParagraphWordcloudBlock =>
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_page_grid_guard(t) ?
    paragraph_page_grid_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_sections_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeSectionsFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_sections_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeSectionsFieldParagraphsItem>): List<ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphFormstackBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphPageGrid | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphFormstackBlock | ParsedParagraphNewsletterSignupForm | ParsedParagraphPageGrid | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_sections_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_sections_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const node_sections_parser = (t: NodeSections): ParsedNodeSections => ({
  ...node_base_parser(t),
  bundle: ((_: any): "sections" => "sections")(t.type),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_jumbo_small: singular_optional_boolean_parser(t.field_jumbo_small),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_media: singular_optional_entity_reference_media_with_target_node_sections_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_sections_field_paragraphs_parser(t.field_paragraphs),
  field_short_description: singular_optional_string_parser(t.field_short_description)
})

export const node_sections_guard = (t: Node): t is NodeSections => node_bundle_parser(t.type) == "sections"

export const entity_reference_media_with_target_node_vacancy_field_media_item_parser = (t: EntityReferenceMediaWithTargetNodeVacancyFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_vacancy_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeVacancyFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_vacancy_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeVacancyFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_vacancy_field_media_item_guard(f[0]) ? entity_reference_media_with_target_node_vacancy_field_media_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_vacancy_field_paragraphs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeVacancyFieldParagraphsItem): ParsedParagraphText | ParsedParagraphImages | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphImages | ParagraphCtaBlock | ParagraphCaroussel | ParagraphContentGrid | ParagraphFormstackBlock | ParagraphHighlight | ParagraphKnop | ParagraphMedia | ParagraphNewsletterSignupForm | ParagraphQuote | ParagraphFaqCollection | ParagraphWordcloudBlock): ParsedParagraphText | ParsedParagraphImages | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_images_guard(t) ?
    paragraph_images_parser(t) :
  paragraph_cta_block_guard(t) ?
    paragraph_cta_block_parser(t) :
  paragraph_caroussel_guard(t) ?
    paragraph_caroussel_parser(t) :
  paragraph_content_grid_guard(t) ?
    paragraph_content_grid_parser(t) :
  paragraph_formstack_block_guard(t) ?
    paragraph_formstack_block_parser(t) :
  paragraph_highlight_guard(t) ?
    paragraph_highlight_parser(t) :
  paragraph_knop_guard(t) ?
    paragraph_knop_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_newsletter_signup_form_guard(t) ?
    paragraph_newsletter_signup_form_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_faq_collection_guard(t) ?
    paragraph_faq_collection_parser(t) :
    paragraph_wordcloud_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_vacancy_field_paragraphs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeVacancyFieldParagraphsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_vacancy_field_paragraphs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeVacancyFieldParagraphsItem>): List<ParsedParagraphText | ParsedParagraphImages | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock> =>
    List<ParsedParagraphText | ParsedParagraphImages | ParsedParagraphCtaBlock | ParsedParagraphCaroussel | ParsedParagraphContentGrid | ParsedParagraphFormstackBlock | ParsedParagraphHighlight | ParsedParagraphKnop | ParsedParagraphMedia | ParsedParagraphNewsletterSignupForm | ParsedParagraphQuote | ParsedParagraphFaqCollection | ParsedParagraphWordcloudBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_vacancy_field_paragraphs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_vacancy_field_paragraphs_item_parser(i)).filter(i => i !== undefined))

export const node_vacancy_parser = (t: NodeVacancy): ParsedNodeVacancy => ({
  ...node_base_parser(t),
  bundle: ((_: any): "vacancy" => "vacancy")(t.type),
  field_category: singular_required_entity_reference_taxonomy_term_parser(t.field_category),
  field_description: singular_optional_text_long_parser(t.field_description),
  field_elastic_index: singular_optional_boolean_parser(t.field_elastic_index),
  field_header_button_url: singular_optional_link_parser(t.field_header_button_url),
  field_header_title: singular_required_string_parser(t.field_header_title),
  field_jumbo_small: singular_optional_boolean_parser(t.field_jumbo_small),
  field_keywords: singular_optional_string_parser(t.field_keywords),
  field_locations: plural_entity_reference_node_parser(t.field_locations),
  field_media: singular_optional_entity_reference_media_with_target_node_vacancy_field_media_parser(t.field_media),
  field_meta_tags: singular_optional_metatag_parser(t.field_meta_tags),
  field_paragraphs: plural_entity_reference_revisions_paragraph_with_target_node_vacancy_field_paragraphs_parser(t.field_paragraphs),
  field_short_description: singular_optional_string_parser(t.field_short_description),
  field_subtitle: singular_required_string_parser(t.field_subtitle)
})

export const node_vacancy_guard = (t: Node): t is NodeVacancy => node_bundle_parser(t.type) == "vacancy"

export const node_parser = (t: Node): ParsedNode =>
  node_activity_clusters_guard(t) ?
    node_activity_clusters_parser(t) :
  node_activity_detail_guard(t) ?
    node_activity_detail_parser(t) :
  node_blog_overview_guard(t) ?
    node_blog_overview_parser(t) :
  node_blog_post_guard(t) ?
    node_blog_post_parser(t) :
  node_collection_overview_guard(t) ?
    node_collection_overview_parser(t) :
  node_event_guard(t) ?
    node_event_parser(t) :
  node_faq_guard(t) ?
    node_faq_parser(t) :
  node_home_guard(t) ?
    node_home_parser(t) :
  node_location_guard(t) ?
    node_location_parser(t) :
  node_location_detail_guard(t) ?
    node_location_detail_parser(t) :
  node_location_overview_guard(t) ?
    node_location_overview_parser(t) :
  node_news_item_guard(t) ?
    node_news_item_parser(t) :
  node_news_overview_guard(t) ?
    node_news_overview_parser(t) :
  node_newsletter_guard(t) ?
    node_newsletter_parser(t) :
  node_page_guard(t) ?
    node_page_parser(t) :
  node_report_guard(t) ?
    node_report_parser(t) :
  node_report_overview_guard(t) ?
    node_report_overview_parser(t) :
  node_sections_guard(t) ?
    node_sections_parser(t) :
    node_vacancy_parser(t)

export const node_guard = (t: Entity): t is Node => (
  (t as any).nid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).type !== undefined &&
  (t as any).type[0].target_type == "node_type" &&
  (t as any).revision_timestamp !== undefined &&
  (t as any).revision_uid !== undefined &&
  (t as any).revision_log !== undefined &&
  (t as any).status !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).title !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).promote !== undefined &&
  (t as any).sticky !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).moderation_state !== undefined &&
  (t as any).metatag !== undefined &&
  (t as any).publish_on !== undefined &&
  (t as any).unpublish_on !== undefined &&
  (t as any).publish_state !== undefined &&
  (t as any).unpublish_state !== undefined
)

export const entity_reference_taxonomy_vocabulary_item_parser = (t: EntityReferenceTaxonomyVocabularyItem): ParsedEntityReferenceTaxonomyVocabularyItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_taxonomy_vocabulary_parser = (f: FieldItemList<EntityReferenceTaxonomyVocabularyItem>): ParsedEntityReferenceTaxonomyVocabularyItem => entity_reference_taxonomy_vocabulary_item_parser(f[0])

export const taxonomy_term_bundle_parser = (f: FieldItemList<EntityReferenceTaxonomyVocabularyItem>): string => f[0].target_id

export const taxonomy_term_base_parser = (t: TaxonomyTermBase): ParsedTaxonomyTermBase => ({
  entity_type: ((_: any): "taxonomy_term" => "taxonomy_term")(t),
  id: singular_optional_integer_parser(t.tid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.name),
  revision_created: singular_optional_created_parser(t.revision_created),
  revision_user: singular_optional_entity_reference_user_parser(t.revision_user),
  revision_log_message: singular_optional_string_long_parser(t.revision_log_message),
  status: singular_optional_boolean_parser(t.status),
  description: singular_optional_text_long_parser(t.description),
  weight: singular_optional_integer_parser(t.weight),
  parent: plural_entity_reference_taxonomy_term_parser(t.parent),
  changed: singular_optional_changed_parser(t.changed),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  metatag: plural_metatag_computed_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  publish_on: singular_optional_timestamp_parser(t.publish_on),
  unpublish_on: singular_optional_timestamp_parser(t.unpublish_on),
  publish_state: singular_optional_list_string_parser(t.publish_state),
  unpublish_state: singular_optional_list_string_parser(t.unpublish_state),
  content_translation_source: singular_optional_language_parser(t.content_translation_source),
  content_translation_outdated: singular_optional_boolean_parser(t.content_translation_outdated),
  content_translation_uid: singular_optional_entity_reference_user_parser(t.content_translation_uid),
  content_translation_created: singular_optional_created_parser(t.content_translation_created),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const taxonomy_term_area_parser = (t: TaxonomyTermArea): ParsedTaxonomyTermArea => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "area" => "area")(t.vid)
})

export const taxonomy_term_area_guard = (t: TaxonomyTerm): t is TaxonomyTermArea => taxonomy_term_bundle_parser(t.vid) == "area"

export const taxonomy_term_blog_category_parser = (t: TaxonomyTermBlogCategory): ParsedTaxonomyTermBlogCategory => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "blog_category" => "blog_category")(t.vid)
})

export const taxonomy_term_blog_category_guard = (t: TaxonomyTerm): t is TaxonomyTermBlogCategory => taxonomy_term_bundle_parser(t.vid) == "blog_category"

export const taxonomy_term_childcare_type_parser = (t: TaxonomyTermChildcareType): ParsedTaxonomyTermChildcareType => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "childcare_type" => "childcare_type")(t.vid)
})

export const taxonomy_term_childcare_type_guard = (t: TaxonomyTerm): t is TaxonomyTermChildcareType => taxonomy_term_bundle_parser(t.vid) == "childcare_type"

export const taxonomy_term_tag_parser = (t: TaxonomyTermTag): ParsedTaxonomyTermTag => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "tag" => "tag")(t.vid)
})

export const taxonomy_term_tag_guard = (t: TaxonomyTerm): t is TaxonomyTermTag => taxonomy_term_bundle_parser(t.vid) == "tag"

export const taxonomy_term_vacancy_category_parser = (t: TaxonomyTermVacancyCategory): ParsedTaxonomyTermVacancyCategory => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "vacancy_category" => "vacancy_category")(t.vid)
})

export const taxonomy_term_vacancy_category_guard = (t: TaxonomyTerm): t is TaxonomyTermVacancyCategory => taxonomy_term_bundle_parser(t.vid) == "vacancy_category"

export const taxonomy_term_parser = (t: TaxonomyTerm): ParsedTaxonomyTerm =>
  taxonomy_term_area_guard(t) ?
    taxonomy_term_area_parser(t) :
  taxonomy_term_blog_category_guard(t) ?
    taxonomy_term_blog_category_parser(t) :
  taxonomy_term_childcare_type_guard(t) ?
    taxonomy_term_childcare_type_parser(t) :
  taxonomy_term_tag_guard(t) ?
    taxonomy_term_tag_parser(t) :
    taxonomy_term_vacancy_category_parser(t)

export const taxonomy_term_guard = (t: Entity): t is TaxonomyTerm => (
  (t as any).tid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).revision_id !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).vid[0].target_type == "taxonomy_vocabulary" &&
  (t as any).revision_created !== undefined &&
  (t as any).revision_user !== undefined &&
  (t as any).revision_log_message !== undefined &&
  (t as any).status !== undefined &&
  (t as any).name !== undefined &&
  (t as any).description !== undefined &&
  (t as any).weight !== undefined &&
  (t as any).parent !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).metatag !== undefined &&
  (t as any).publish_on !== undefined &&
  (t as any).unpublish_on !== undefined &&
  (t as any).publish_state !== undefined &&
  (t as any).unpublish_state !== undefined &&
  (t as any).content_translation_source !== undefined &&
  (t as any).content_translation_outdated !== undefined &&
  (t as any).content_translation_uid !== undefined &&
  (t as any).content_translation_created !== undefined
)

export const input_entity_parser = (t: InputEntity): ParsedInputEntity =>
  node_guard(t) ?
    node_parser(t) :
    taxonomy_term_parser(t)

export const entity_parser = (t: Entity): ParsedEntity =>
  node_guard(t) ?
    node_parser(t) :
  paragraph_guard(t) ?
    paragraph_parser(t) :
  media_guard(t) ?
    media_parser(t) :
  file_guard(t) ?
    file_parser(t) :
    taxonomy_term_parser(t)

export const input_entity_guard = (t: any): t is InputEntity => (
  node_guard(t as InputEntity) ||
  taxonomy_term_guard(t as InputEntity)
)

export const entity_guard = (t: any): t is Entity => (
  node_guard(t as Entity) ||
  paragraph_guard(t as Entity) ||
  media_guard(t as Entity) ||
  file_guard(t as Entity) ||
  taxonomy_term_guard(t as Entity)
)